import { API_TYPE } from "@common/api/api.service";
import { FieldProcess, ValueSourceTypeEnum, FieldOperationEnum, SetTypeEnum, FieldEventTypeEnum, FieldProcessTypeEnum } from "@common/model/analytics.model";
import { FORMS_MODULE, NULL_TEXT } from "@common/model/constants";
import { IBroadcastService } from "@common/service/broadcast.service";
import angular from "angular";
import _ from "lodash";
import moment from "moment";
import { Util } from "@common/util";
import * as jsonLogic from "json-logic-js";
import * as RespModel from "@common/model/model.definition";
import { Document } from "@common/model/model.definition";



    export const POPUP_TYPE = {
        CUSTOM_ATTRS: 'customAttributes',
        REPORTS: 'reports'
    }
    export const FIELD_TYPE = {
        NUMBER: 'number',
        DATE: 'date',
        TEXTAREA: 'textarea',
        RTF_TEXTAREA: 'rtftextarea',
        UI_SELECT: 'uibselect',
        DYN_UI_SELECT: 'dynamicList',
        SINGLE_SELECT: 'single-select',
        SINGLE_SELECT_STRING: 'single-select-string',
        MULTI_SELECT: 'multi-select',
        PHONE: 'phone',
        EXT: 'extension',
        PHONE_NUMBER: 'phoneNumber',
        TIME_PICKER: 'timePicker',
        SIGNATURE: 'signature',
        FIELDSET: 'fieldset',
        COMPOSITE_LIST: 'compositeList',
        SINGLE_FIELD: 'singleFieldList',
        SCALE: 'scale',
        COMPOSITE: 'composite',
        HYPERLINK: 'hyperlink',
        TABLE: 'table',
        CHECKBOX: 'checkbox',
        FILE_UPLOAD: 'fileUpload',
        UPLOAD_PIC: 'uploadPic',
        SUBJECTS: 'subjectsList',
        USERS: 'usersList',
        TEXT : 'text',
        CHECKBOXES : 'ecv-checkboxes'
    };
    export class FormsUtility {
        parseForm: Function;
        parseSection: Function;
        parseField: Function;
        convertToFormFieldType: Function;
        convertToSchemaFieldType: Function;
        getSchemaFieldFormat: Function;
        getFieldHtmlClass: Function;
        getHtmlClass: Function;
        getFieldWidth: Function;
        addCustomValidators: Function;
        addCustomTypeProperties: Function;
        parseModel: Function;
        addSchema: Function;
        parseFieldSchema: Function;
        parsedForm;
        parsedSchema;
        parsedModel;
        deferredModel;
        modelBak;
        readOnly: boolean;
        fieldCounter: number;
        requiredFlds;
        parsedDependencies: any = {};     //This keeps track of dependent fields, to be used to reset dependent fields
        fetchField;
        parseItems;
        changeRqdCls;
        orgId;
        orgPartyId;
        currentUser;
        subject;
        depModel;
        generateResponse: Function;
        timePckrFlds = [];
        parseErrors: Function;
        bckndErrors;
        resetBckndErrors: Function;
        chckRq: Function;
        getCndStr: Function;
        subjectId;
        isModelChanged: Function;
        setDefaultFieldValue: Function;
        autofill: Function;
        autofilled = [];
        openPopup: Function;
        navigateTo: Function;
        fieldCount: number = 0;
        filterBarriers: Function;
        resolveBarrier: Function;
        deleteBarrier: Function;
        fldOnChange: (action: any, result: any, index?: any) => void;
        callService: (service: any, source: any, index?: any) => any;
        handleProcess: (process: FieldProcess, result?: any, index?: any) => any;
        fetchValueSource: (actn: any, result: any) => {};
        checkReqFldValidation = [];
        crntUserIsOfSubjOrg;
        isUsrCaptainOrCocaptain;
        usrPswd;
        usrSgn;
        formOrgId;
        penddingDynUiSelect: Function;
        pendingDUS = 0;
        apiKey;
        formUsers;
        selSubjId: any;
        skipFields: any = [];
        canUsrEdit: Function;
        formConfig;
        loadMore :boolean = true;
        selectedSubject;
        service;
        parsedFieldLabels: any = {};
        signFlds = [];
        setUsrSignature: Function;
        frmSaved: boolean;
        dynamicFields = {};
        isReadOnly;
        parsedSignature: any;
        parseSignature: Function;
        handleSignatureFlds: Function;
        fieldConfigurationsData: any = {};
        resetCntrForTrial;
        resetTimeout;
        submittedForm: boolean = false;
        dateSubmitted = "active";
        activeGoals = null;
        $filter;
        $q;
        FieldService;
        $_api;
        APIService;
        $_cache;
        $uibModal;
        $_com;
        $_modLoadService: any;
        moment;
        $scope;
        $_snack;
        $_utilitySer;
        $state;
        FormService;
        parsedErrors;
        parseBackendErrors: Function;
        getErrorCode: Function;
        checkPermission: Function;
        teamOrgId;
        PopUpService;
        cstmAttrFlds = [];
        isMultipleTeams = false;
        modelUpdated = false;
        filterArray: Function;
        SubjectService;
        validationMsg;
        pendingParsedFields;
        formParsed;
        $interval;
        handleErrors : Function;
        handleRequiredFieldValidations : Function;
        autofillObj;
        cmpareObj: Function;
        mapArrays: Function;
        reduceArrayByProperties: Function; // @iantripp for Coaching Tools
        addFieldInArrayObject:Function;
        setModel;
        setModelBak;
        setIntervalToCheckParsedFieldStatus;
        promise;
        BroadcastService : IBroadcastService;
        setDynDrpdwnVal: Function;
        dupVal = [];
        dupSysVal = [];
        checkDuplicate: Function
        checkSysDuplicate: Function;
        completeGoal: (index: any, fldKey: any, mdl: any) => void;
        deleteItem: (index: any, fldKey: any, mdl: any) => void;
        editItem: (index: any, fldKey: any, mdl: any) => void;
        parseStateGroups: (result: any) => any[];
        stateGroupBy: (item: any) => any;
        parseTeamRoles: (result: any) => any;
        constructor(private ctrl, private formName) {

                this.$filter = this.ctrl.$filter;
                this.$q = this.ctrl.$q;
                this.FieldService = this.ctrl.FieldService;
                this.$_api = this.ctrl.$_api;
                this.APIService = this.ctrl.APIService;
                this.$_cache = this.ctrl.$_cache;
                this.$uibModal = this.ctrl.$uibModal;
                this.$_com = this.ctrl.$_com;
                this.moment = this.ctrl.moment;
                this.$scope = this.ctrl.$scope;
                this.$_snack = this.ctrl.$_snack;
                this.$_utilitySer = this.ctrl.$_utilitySer;
                this.$state = this.ctrl.$state;
                this.FormService = this.ctrl.FormService;
                this.PopUpService = this.ctrl.PopUpService;
                this.SubjectService = this.ctrl.SubjectService;
                this.$interval = this.ctrl.$interval;
                this.BroadcastService = this.ctrl.BroadcastService;
                this.$_modLoadService = this.ctrl.ConditionalModuleLoadService;
            this.getFieldWidth = (width: string, grids: number) => {
                let fldWdth = width;
                if (width.endsWith('%')) {
                    var p = parseFloat(width);
                    fldWdth = '' + Math.ceil(grids * p / 100);
                } else if (width.indexOf('/') != -1) {
                    fldWdth = '' + Math.ceil(eval(width) * grids);
                }
                return fldWdth;
            }

            this.getCndStr = (dependency) => {
                let cndStr = '', type = dependency['dependType'], lbl = !!this.parsedFieldLabels[dependency['dependsOn']]? this.parsedFieldLabels[dependency['dependsOn']] : dependency['dependsOn'], val = dependency['dependValue'];
                if (!!dependency['jsonCondition']) {
                    try {
                        let jsonCnd = Util.isJsonString(dependency['jsonCondition'])? JSON.parse(dependency['jsonCondition']) : dependency['jsonCondition'];
                        Object.keys(jsonCnd).forEach(k => {
                            let dep = jsonCnd[k];
                            let arr = [];
                            switch (k.toLowerCase()) {
                                case "or":
                                    arr = [];
                                    dep.forEach(d => {
                                        arr.push(this.getCndStr(d));
                                    });
                                    cndStr = '(' + arr.join(' || ') + ')';
                                    break;
                                case "and":
                                    arr = [];
                                    dep.forEach(d => {
                                        arr.push(this.getCndStr(d));
                                    });
                                    cndStr = '(' + arr.join(' && ') + ')';
                                    break;
                            }
                        });
                    } catch (e) {
                        console.log("error in parsing dependency: ", dependency['jsonCondition']);
                    }
                } else {
                    switch (type) {
                        case 'value':
                        case 'et':
                        case 'equals':
                            cndStr = "model." + lbl + "=='" + val + "'";
                            break;
                        case 'notValue':
                        case 'notEt':
                        case 'notEquals':
                            cndStr = "(!!model." + lbl +
                                " && model." + lbl + "!='" + val + "')";
                            break;
                        case 'lt':
                        case 'lessThan':
                            cndStr = "model." + lbl + "<'" + val + "'";
                            break;
                        case 'ltet':
                        case 'lessThanOrEquals':
                            cndStr = "model." + lbl + "<='" + val + "'";
                            break;
                        case 'gt':
                        case 'greaterThan':
                            cndStr = "model." + lbl + ">'" + val + "'";
                            break;
                        case 'gtet':
                        case 'greaterThanOrEquals':
                            cndStr = "model." + lbl + ">='" + val + "'";
                            break;
                        case 'notEmpty':
                            cndStr = "model." + lbl;
                            break;
                        case 'empty':
                            cndStr = "(!model." + lbl + " || model." + lbl + ".length == 0)";
                            break;
                        case 'includes':
                            cndStr = "model." + lbl + ".includes(" + val + ")";
                            break;
                        case 'modelChanged':
                            cndStr = "model." + lbl + "!=" + "modelBak." + lbl ;
                            break;
                        case 'default':
                            cndStr = '';
                            break;
                    }
                }
                cndStr = _.replace(cndStr, new RegExp('\\[]', 'g'), '[arrayIndex]');
                return cndStr;
            }

            this.getHtmlClass = (field: any, readOnly) => {
                var htmlClass = '', col = " col-md-",displayOptions = field.displayOptions;

                if(!!field.htmlClass){
                    htmlClass += field.htmlClass;
                }
                if(!!displayOptions && displayOptions.inputType != 'label'){
                    htmlClass += " field-" + this.fieldCounter;
                }
                if(_.includes(this.requiredFlds, field.key) || field.required){
                    htmlClass += " parent-div-" + field.key;
                }
                if(readOnly){
                    htmlClass += " div-disabled";
                }

                if(!this.canUsrEdit(field.roles)){
                    htmlClass += " no-edit-role";
                }

                if (!!displayOptions && !!displayOptions.width) {
                    htmlClass += " col-xs-12";
                    var fieldWidth = this.getFieldWidth(displayOptions.width, 12);
                    if(displayOptions.inputType == 'multiple' || field.type == FIELD_TYPE.SIGNATURE){
                        htmlClass += " col-md-12";
                    } else {
                        htmlClass += col + fieldWidth;
                    }
                }

                return htmlClass;
            }

            this.getFieldHtmlClass = (displayOptions: any) => {
                var fieldHtmlClass = "";
                if (!!displayOptions) {
                    if (!!displayOptions.transformCase) {
                        switch (displayOptions.transformCase) {
                            case "toUpperCase":
                                fieldHtmlClass += " text-uppercase";
                                break;
                            case "toLowerCase":
                                fieldHtmlClass += " text-lowercase";
                                break;
                        }
                    }

                    if (!!displayOptions.resize) {
                        fieldHtmlClass += " allow-resize";
                    }
                    if (!!displayOptions.fontSize) {
                        fieldHtmlClass += ' label-text-' + displayOptions.fontSize;
                    }
                    if (!!displayOptions.alignment) {
                        fieldHtmlClass += ' label-text-' + displayOptions.alignment;
                    }
                    if (!!displayOptions.fieldClass) {
                        fieldHtmlClass += ' ' + displayOptions.fieldClass;
                    }
                }

                return fieldHtmlClass;
            }

            this.convertToFormFieldType = (type: string, options: any) => {
                let retType = "";
                switch (type){
                    case "text":
                        if (!!options) {
                            if (options.inputType == FIELD_TYPE.TEXTAREA) {
                                retType = "ecv-" + FIELD_TYPE.TEXTAREA;
                            } else if (options.inputType == FIELD_TYPE.RTF_TEXTAREA) {
                                retType = FIELD_TYPE.RTF_TEXTAREA;
                            } else {
                                retType = "ecv-text";
                            }
                        } else {
                            retType = "ecv-text";
                        }
                        break;
                    case "date":
                        retType = "uidatepicker";
                        break;
                    case "list":
                        retType = FIELD_TYPE.UI_SELECT;
                        break;
                    case "scale":
                        if (!!options && options.webType == "radio") {
                            retType = "ecv-radios";
                        } else if (!!options && options.webType == "rating") {
                            retType = "rating";
                        }
                        break;
                    case "array":
                        if (options.inputType == "tags") {
                            retType = "ecv-checkboxes";
                        } else{
                            retType = "checkboxes";
                        }
                        break;
                    case FIELD_TYPE.COMPOSITE:
                    case FIELD_TYPE.PHONE_NUMBER:
                        retType = "fieldset";
                        break;
                    case FIELD_TYPE.PHONE:
                    case FIELD_TYPE.EXT:
                        retType = "ecv-text";
                        break;
                    case FIELD_TYPE.COMPOSITE_LIST:
                        retType = FIELD_TYPE.COMPOSITE_LIST
                        if (!!options && options.inputType == FIELD_TYPE.SINGLE_FIELD) {
                            retType = FIELD_TYPE.SINGLE_FIELD;
                        }
                        break;

                    case FIELD_TYPE.CHECKBOX:
                        retType = "ecv-checkbox"
                        break;
                    default:
                        retType = type;
                }
                return retType;
            }

            this.convertToSchemaFieldType = (type: string, options: any) => {
                let res;
                switch(type){
                    case "text":
                        if(options.inputType == "number")
                            res = "number";
                        else
                            res = "string";
                        break;
                    case "label":
                    case "label-alt":
                    case FIELD_TYPE.PHONE:
                    case FIELD_TYPE.EXT:
                    case FIELD_TYPE.UPLOAD_PIC:
                        res = "string";
                        break;
                    case "date":
                        res = "date";
                        break;
                    case FIELD_TYPE.TIME_PICKER:
                        res = "time";
                        break;
                    case "counter":
                    case "list":
                        if (options.inputType == "string")
                            res = "string";
                        else
                            res = "number";
                        break;
                    case "scale":
                        if (!!options && _.includes(["rating","radio"],options.webType)) {
                            res = "number";
                        }
                        break;
                    case FIELD_TYPE.DYN_UI_SELECT:
                        if(options.inputType == FIELD_TYPE.SINGLE_SELECT){
                            if (options.returnType == "string")
                                res = "string";
                            else
                                res = "number";
                        } else if(options.inputType == FIELD_TYPE.SINGLE_SELECT_STRING)
                            res = "string";
                        else
                            res = "array";
                        break;
                    case FIELD_TYPE.COMPOSITE_LIST:
                    case "array":
                    case FIELD_TYPE.TABLE:
                    case "fieldArray":
                        res = "array";
                        break;
                    case FIELD_TYPE.FILE_UPLOAD:
                    case FIELD_TYPE.SIGNATURE:
                    case FIELD_TYPE.HYPERLINK:
                        res = "object";
                        break;
                    case FIELD_TYPE.COMPOSITE:
                        res = "fieldset";
                        break;
                    case FIELD_TYPE.CHECKBOX:
                        res = "boolean";
                        break;
                    case FIELD_TYPE.SUBJECTS:
                        if(options.inputType == "single-select")
                            res = "object";
                        else //multi-select
                            res = "array";
                        break;
                    case FIELD_TYPE.USERS:
                        if(options.inputType == "single-select")
                            res = "object";
                        else //multi-select
                            res = "array";
                        break;
                    case FIELD_TYPE.NUMBER:
                        if(options.inputType == "integer")
                            res = "integer";
                        else
                            res = "number";
                        break;
                    default:
                        res = type;
                        break;
                }
                return res;
            }

            this.getSchemaFieldFormat = (type: string) => {
                switch (type) {
                    case "date":
                        return "date";
                    default:
                        return null;
                }
            }
            var adjustDate = function(res, action, unit, qty , returnDate = true){
                    if(res === null || res === undefined || res === ''){
                        return null;
                    }
                    let src = moment(res);
                    if(!src.isValid()){
                        return null;
                    }
                    let dt;
                    if(action == 'add'){
                        dt = src.add(qty, unit);
                    } else {
                        dt = src.subtract(qty, unit);
                    }
                    if(!dt.isValid()){
                        return null;
                    }
                    let ans = returnDate ? dt.toDate() : dt.valueOf();
                    return ans;
            }

            jsonLogic.add_operation("adjustDate", adjustDate);

            this.addCustomValidators = (field: any, tempField: any) => {
                var context = this;
                var ind, tableIndex;
                var replaceParams = (params, value=null) => {
                    if(typeof params == 'object') {
                        for(let p in params){
                            params[p] = replaceParams(params[p], value);
                        }
                    }
                    if(typeof params == 'string'){
                        params = _.replace(params, '${_index_}', ind);
                        params = _.replace(params, '${_tableIndex_}', tableIndex);
                        params = _.replace(params, '${_result_}', value);
                        let keys = params.split('.');
                        keys[0] = !!this.parsedFieldLabels[keys[0]]? this.parsedFieldLabels[keys[0]] : keys[0];
                        params = keys.join('.');
                    }
                    return params;
                }
                tempField['ngModel'] = function (ngModel) {
                    //readonly can be a boolean or an angular expression string
                    var isFieldReadonly = function (): boolean {
                        const ro = tempField.readonly;
                        if (typeof ro === 'boolean') return ro;
                        if (!ro) return false;
                        const scope = ngModel.$$scope;
                        const locals = {
                            model: scope.model,
                            form: tempField,
                            arrayIndex: scope.arrayIndex,
                            arrayIndices: scope.arrayIndices,
                            tableIndex: scope.tableIndex,
                            item: scope.item
                        };
                        try {
                            return !!(scope.evalExpr ? scope.evalExpr(ro, locals) : scope.$eval(ro, locals));
                        } catch (e) {
                            return false;
                        }
                    };

                    if (!!field.fieldOptions && !!field.fieldOptions.legalChars) {
                        var pf = function (value) {
                            if (value && value.replace) {
                                var expression = field.fieldOptions.legalChars;
                                var rx = new RegExp(expression, "g");
                                var transformedInput = value.replace(rx, '');
                                ngModel.$setViewValue(transformedInput);
                                ngModel.$render();
                                return transformedInput;
                            }
                            return value;
                        };
                        ngModel.$parsers.push(pf);
                        ngModel.$formatters.push(pf);
                    }

                    if(field.fieldOptions && field.fieldOptions.cstmValidator) {
                        let cstmValidator = field.fieldOptions.cstmValidator;
                        ngModel.$validators[cstmValidator.name] = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                let data = context.fetchValueSource(cstmValidator, value);
                                let rule = replaceParams(_.cloneDeep(cstmValidator.rule), value);
                                return jsonLogic.apply(rule, data);
                            } else {
                                return true;
                            }
                        }
                    }

                    if (!!field.fieldOptions && !!field.fieldOptions.regex) {
                        ngModel.$validators.regex = function (value) {
                            if (!!value) {
                                var expression = field.fieldOptions.regex;
                                var rx = new RegExp(expression, "g");
                                return rx.test(value);
                            } else {
                                return true;
                            }
                        }
                    }

                    if(field.fieldOptions.equalValue) {
                        ngModel.$validators.equalValue = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                var answer;
                                ind = ngModel.$$scope.$parent.$parent.$index;
                                let fld = replaceParams(_.cloneDeep(field.fieldOptions.equalValue.sfield))
                                answer = _.get(context.parsedModel, fld);

                                if (value ==  answer) {
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                return true;
                            }
                        }
                    }

                    if(field.fieldOptions.depMinDate) {
                        ngModel.$validators.depMinDate = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                var tempMDate;
                                ind = ngModel.$$scope.$parent.$parent.$index;
                                let fld = replaceParams(_.cloneDeep(field.fieldOptions.depMinDate.sfield));
                                tempMDate = _.get(context.parsedModel, fld);
                                !!field.fieldOptions.depMinDate.condition && (tempMDate = jsonLogic.apply(field.fieldOptions.depMinDate.condition, {"result": tempMDate}))
                                var mDate = Util.getUTCTime(tempMDate);

                                var tempVDate = new Date(value);
                                var vDate = Util.getUTCTime(tempVDate);

                                if (vDate < mDate) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        }
                    }

                    if(field.fieldOptions.depMaxDate) {
                        ngModel.$validators.depMaxDate = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                var tempMDate;
                                ind = ngModel.$$scope.$parent.$parent.$index;
                                let fld = replaceParams(_.cloneDeep(field.fieldOptions.depMaxDate.sfield));
                                tempMDate = _.get(context.parsedModel, fld);
                                !!field.fieldOptions.depMaxDate.condition && (tempMDate = jsonLogic.apply(field.fieldOptions.depMaxDate.condition, {"result": tempMDate}))
                                var mDate = Util.getUTCTime(tempMDate);

                                var tempVDate = new Date(value);
                                var vDate = Util.getUTCTime(tempVDate);

                                if (vDate > mDate) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        }
                    }

                    if (!!field.fieldOptions && !!field.fieldOptions.minDate &&
                        (isNaN(parseFloat(field.fieldOptions.minDate)) || parseFloat(field.fieldOptions.minDate) >= 0)) {
                        ngModel.$validators.minDate = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                var tempMDate;
                                if (isNaN(parseFloat(field.fieldOptions.minDate))) {
                                    if (field.fieldOptions.minDate === "CURRENT_DATE") {
                                        tempMDate = new Date();
                                    } else if(field.fieldOptions.minDate === "CUSTOM_DATE"){
                                         //adjustedValue : difference of dates in milli seconds
                                        tempMDate =  jsonLogic.apply( {"adjustDate" : [new Date() , ...field.fieldOptions['adjustedMinDate'] ]} )
                                    }
                                } else if (parseFloat(field.fieldOptions.minDate) >= 0) {
                                    tempMDate = new Date(parseFloat(field.fieldOptions.minDate));
                                }
                                var mDate = Util.getUTCTime(tempMDate);

                                var tempVDate = new Date(value);
                                var vDate = Util.getUTCTime(tempVDate);

                                if (vDate < mDate) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        }
                    }
                    if (!!field.fieldOptions && !!field.fieldOptions.maxDate &&
                        (isNaN(parseFloat(field.fieldOptions.maxDate)) || parseFloat(field.fieldOptions.maxDate) >= 0)) {
                        ngModel.$validators.maxDate = function (value) {
                            if (!!value && !isFieldReadonly()) {
                                var tempMDate;
                                if (isNaN(parseFloat(field.fieldOptions.maxDate))) {
                                    if (field.fieldOptions.maxDate === "CURRENT_DATE") {
                                        tempMDate = new Date();
                                    }
                                } else if (parseFloat(field.fieldOptions.maxDate) >= 0) {
                                    tempMDate = new Date(parseFloat(field.fieldOptions.maxDate));
                                }

                                var mDate = Util.getUTCTime(tempMDate);

                                var tempVDate = new Date(value);
                                var vDate = Util.getUTCTime(tempVDate);

                                if (vDate > mDate) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        }
                    }
                    if (field.type == "date") {
                        ngModel.$validators.date = function (value) {
                            if (!!value) {
                                if (Object.prototype.toString.call(value) === "[object Date]") {
                                    if (isNaN(value.getTime())) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                                }
                                else {
                                    return false;
                                }
                            } else {
                                return true;
                            }
                        }
                    }
                    if(field.type == FIELD_TYPE.PHONE){
                        ngModel.$validators.reqCls = function (value) {
                            if (!!value) {
                                $(".parent-div-"+tempField.key[0]).removeClass('req-fld-div');
                            }
                            return true;
                        }
                    }
                    if (!!field.fieldOptions) {
                        if (!!field.fieldOptions.minDigits) {
                            ngModel.$validators.minLength = function (value) {
                                if (!!value) {
                                    var cleaned = ('' + value).replace(/\D/g, '');
                                    if (cleaned.length < field['fieldOptions']['minDigits']) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                }
                                return true;
                            }
                        }
                        if (!!field.fieldOptions.maxDigits) {
                            ngModel.$validators.maxLength = function (value) {
                                if (!!value) {
                                    var cleaned = ('' + value).replace(/\D/g, '');
                                    if (cleaned.length > field['fieldOptions']['maxDigits']) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                }
                                return true;
                            }
                        }
                    }
                }



                if (field.type == FIELD_TYPE.PHONE) {
                    tempField['validationMessage']['minLength'] = 'Must be a ' + field.fieldOptions['minDigits'] + '-digit number.';
                    tempField['validationMessage']['maxLength'] = 'Must be a ' + field.fieldOptions['maxDigits'] + '-digit number.';
                }
                if (field.type == FIELD_TYPE.EXT) {
                    tempField['validationMessage']['maxLength'] = field.fieldOptions['maxDigits'] + ' digits maximum.';
                }
                return tempField;
            }

            this.addCustomTypeProperties = (field: any) => {
                let context = this;
                field['disable'] = false;
                if (!!field['canEdit']) {
                    let fType = field['type'];
                    //To edit the field
                    field['editField'] = function () {
                        field['editMode'] = true;
                        field['bckp'] = (fType == FIELD_TYPE.UI_SELECT) ? field['dataName'] : context.parsedModel[field.key];
                    }

                    //To cancel the edit field
                    field['cancelField'] = function () {
                        if(fType ==  FIELD_TYPE.UI_SELECT)
                            field['dataName'] = field['bckp'];
                        else
                            context.parsedModel[field.key] = field['bckp'];
                        field['editMode'] = false;
                    }

                    //To save the field
                    field['saveField'] = function () {
                        var deferred = context.$q.defer();
                        if(fType ==  FIELD_TYPE.UI_SELECT) {
                            if(field['dataName'] != field['bckp']) {
                                if(!context.$scope[context.formName][field.key[0]].$valid){
                                    deferred.reject();
                                } else {
                                    var dataId = context.parsedModel[field.key];
                                    let reqObj = {
                                        type: field['dynamicData'],
                                        data: field['dataName'],
                                        attr: 'value',
                                        id: dataId,
                                        subjectId: context.subjectId
                                    };

                                    context.$_api.updateFormDynamicAttribute(reqObj).then((s) => {
                                            let opt = field.options.find(op => op.id == dataId);
                                            opt['name'] = s['value'];
                                            field['editMode'] = false;
                                            deferred.resolve();
                                        },
                                        (e) => {
                                            context.$_snack.showErrorToastr({message: e});
                                            field['editMode'] = false;
                                            deferred.reject();
                                        });
                                }
                            } else {
                                field['editMode'] = false;
                                deferred.resolve();
                            }
                        } else {
                            let txt = jQuery(context.parsedModel[field.key]).text().trim();
                            if (context.parsedModel[field.key] != field['bckp'] && (txt != "" || !!field['bckp'])) {
                                if(!!context.$scope[context.formName] && !context.$scope[context.formName][field.key[0]].$valid){
                                    deferred.reject();
                                } else {
                                    var dependency, parentId;
                                    var filtered = context.parsedModel[field.key].replace(/[&]nbsp[;]/gi, ""); // removes all occurrences of &nbsp;
                                    filtered = filtered.replace(/[<]br[^>]*[>]/gi, "");
                                    filtered = filtered.replace(/"/g, "'");
                                    filtered = filtered.trim();
                                    if (!!field['dynamicData']) {
                                        if (!!field['dependencies'] && field['dependencies'].length > 0) {
                                            dependency = field['dependencies'].find(d => d.dependType == 'setValue');
                                            if (!!dependency) {
                                                parentId = context.parsedModel[dependency['dependsOn']];
                                                let reqObj = {
                                                    type: field['dynamicData'],
                                                    data: filtered,
                                                    attr: dependency['dependValue'],
                                                    id: parentId,
                                                    subjectId: context.subjectId
                                                };

                                                context.$_api.updateFormDynamicAttribute(reqObj).then((s) => {
                                                    let fKey = dependency['dependsOn'];
                                                    let depFld = context.fetchField(context.parsedForm, null, fKey);
                                                    let opt = depFld.options.find(op => op.id == parentId);
                                                    let val = s[dependency['dependValue']];
                                                    opt[dependency['dependValue']] = val;
                                                    if (!val || val.length == 0) {
                                                        field['placeholder'] = field['defaultText'];
                                                    }
                                                    field['editMode'] = false;
                                                    deferred.resolve();
                                                },
                                                    (e) => {
                                                        deferred.reject();
                                                    });
                                            }
                                        }
                                    } else {
                                        context.parsedModel[field.key] = filtered;
                                        field['editMode'] = false;
                                        deferred.resolve();
                                    }
                                }
                            } else {
                                field['editMode'] = false;
                                deferred.resolve();
                            }
                        }
                        return deferred.promise;
                    }
                }
                if (field.type == FIELD_TYPE.RTF_TEXTAREA) {
                    let handler, handlerArr;
                    if (!!field['dynamicData']) {
                        handlerArr = ['save', 'cancel'];
                        handler = {
                            'save': () => {
                                field.saveField();
                            },
                            'cancel': () => {
                                field.cancelField();
                            }
                        };
                    } else {
                        !field['readonly'] && !!field['canEdit'] && (field['editMode'] = true);
                        handlerArr = ['preview'];
                        handler = {
                            'preview': () => {
                                field.saveField();
                            }
                        };
                    }
                    field['quillModules'] = {
                        toolbar: {
                            container: [[{ header: [1, 2, 3, false] }],
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            ['link'], handlerArr],
                            handlers: handler
                        }
                    }
                    field['onContentChange'] = function (editor, html, text, content) {
                        //When text in rtf is deleted, the model is set to undefined
                        // because of which the form throws invalid response error
                        // so changing the model to empty string.
                        if (html == null) {
                            context.parsedModel[field.key] = "";
                        }
                    }
                    field['onEditorCreated'] = function (editor) {
                        context.$_utilitySer.setURLPlaceholder(editor);
                    }
                }
                if (_.includes([FIELD_TYPE.UI_SELECT, FIELD_TYPE.DYN_UI_SELECT], field.type)) {
                    //This would be called recurrsively to reset the model values for all the dependent fields
                    var resetAllDependencies = function (field, fldScope?) {
                        let mdl = context.parsedModel;
                        let dep = context.parsedDependencies[field.key];
                        if (!!dep) {
                            for (let d of dep) {
                                let depFld = context.fetchField(context.parsedForm, null, d['key']);
                                if (d['dependType'] == 'filterOptions') {
                                    mdl[d['key']] = undefined;
                                    let filteredOpts = depFld.options.filter(depFld.filterFunc);
                                    if (depFld.type == FIELD_TYPE.DYN_UI_SELECT) {
                                        depFld['fldConfig']['ddOptions'] = filteredOpts;
                                        depFld['fldConfig']['value'] = undefined;
                                    }
                                    if (!!depFld.selectIfSingle && filteredOpts.length == 1) {
                                        mdl[d['key']] = filteredOpts[0]['id'];
                                        if (depFld.type == FIELD_TYPE.DYN_UI_SELECT) {
                                            depFld['fldConfig']['value'] = filteredOpts[0];
                                        }
                                        $('.parent-div-' + d['key']).removeClass('req-fld-div');
                                    }
                                }
                                else if (d['dependType'] == 'setValue') {
                                    //If the dependent field is rtf and is in edit mode then before
                                    // changing the model cancel the edit mode of rtf
                                    if (depFld['type'] == FIELD_TYPE.RTF_TEXTAREA && depFld['editMode'] == true) {
                                        depFld.cancelField();
                                    }
                                    //Set the model value of the dependent field
                                    if (!mdl[field.key]) {
                                        mdl[d['key']] = undefined;
                                    } else {
                                        let item = field.options.find(o => o.id == mdl[field.key]);
                                        let val = item[d['dependValue']];
                                        mdl[d['key']] = val;
                                        //If the value is not set yet then show a different placeholder
                                        if (!val || val.length == 0) {
                                            if (!depFld['canEdit'] || context.formConfig.readOnly) {
                                                depFld['placeholder'] = depFld['title'];
                                            } else
                                                depFld['placeholder'] = depFld['defaultText'];
                                        }
                                    }
                                }
                                resetAllDependencies(d, fldScope);
                            }

                        }
                    }

                    var resetMultipleDependencies = (field, mltpDep) => {
                        let mdl = context.parsedModel;
                        let dep = mltpDep['dependsOn'].split(',');

                        //If current field is dependent on multiple fields then after all the dependent fields are reset
                        //will have to filter the current field options as well
                        let filteredOpts = field.options.filter(field.filterFunc);
                        if (field.type == FIELD_TYPE.DYN_UI_SELECT) {
                            field['fldConfig']['ddOptions'] = filteredOpts;
                        }

                        //Reset options of all the dependencies
                        for (let d of dep) {
                            let key = !!context.parsedFieldLabels[d]? context.parsedFieldLabels[d] : d;
                            let depFld = context.fetchField(context.parsedForm, null, key);
                            let filteredOpts = depFld.options ? depFld.options.filter(depFld.filterFunc) : [];
                            if (depFld.type == FIELD_TYPE.DYN_UI_SELECT) {
                                depFld['fldConfig']['ddOptions'] = filteredOpts;
                            }
                            if (!!depFld.selectIfSingle && filteredOpts.length == 1) {
                                mdl[key] = filteredOpts[0]['id'];
                                if (depFld.type == FIELD_TYPE.DYN_UI_SELECT) {
                                    depFld['fldConfig']['value'] = filteredOpts[0];
                                }
                                $('.parent-div-' + key).removeClass('req-fld-div');
                            }
                            resetAllDependencies(depFld);
                        }
                    }

                    //To reset all the dropdowns that are dependent on this field
                    field['resetDependent'] = function (event, fldScope) {
                        if (!!field['dependencies']) {
                            let mltpDep = field['dependencies'].find(dep => dep.dependType == 'multipleFilterOptionsNotEqualTo');
                            !!mltpDep && resetMultipleDependencies(field, mltpDep);
                        }
                        resetAllDependencies(field, fldScope);
                        if (field.type == FIELD_TYPE.UI_SELECT) {
                            let nm = field['options'].find(item => item.id == context.parsedModel[field.key]);
                            field['dataName'] = !!nm? nm.name : null;
                        }
                    }
                    if(!!field['dynamicData']){
                        field['canUsrAddData'] = context.crntUserIsOfSubjOrg;
                        //This would open fieldMetadataPop up
                        var setFieldMetadata  = function(searchText,reqObj){
                            field.options.push({id:-9999,name:searchText.trim(),parentId: reqObj.parentId});
                            let backupGoalId = context.parsedModel[field.key[0]];
                            context.parsedModel[field.key[0]] = -9999;
                            ($('.ui-select-container.open').scope() as any).$select.open = false;
                            context.$uibModal.open({
                                templateUrl: 'app/common/popup/fieldMetadataPopup/fieldMetadataPopup.html',
                                controller: 'FieldMetadataPopupController',
                                controllerAs: 'fieldMetadataPopupVm',
                                windowClass: 'field-metadata-modal',
                                backdrop: 'static',
                                resolve: {
                                    formField:() => field,
                                    newGoal:() => searchText,
                                    goalReqObj: () => reqObj
                                }
                            }).result.then(
                                (s)=> {
                                    context.parsedModel[field.key[0]] = s.goalId;
                                    field['options'].push({
                                        id: s.goalId,
                                        name: s.goalName,
                                        parentId: s.parentId
                                    });
                                    field['dynamicDataLoading'] = false;
                                    field['dataName'] = s.goalName;
                                    resetAllDependencies(field);
                                    let success_msg = "IEP Goal "+s.goalName+" created successfully" ;
                                    toastr.success(success_msg, "");
                                },
                                (e) =>{
                                    context.parsedModel[field.key[0]] = backupGoalId;
                                    console.log(e);
                                }).finally(() => {
                                field['options'] = field['options'].filter(goal => goal.id != -9999);
                                field['dynamicDataLoading'] = false;
                            });
                        }

                        //to check whether the exact text is already present
                        field['exactSearchInList'] = function(items,searchText){
                            return !!(items || []).find(itm => context.$_utilitySer.removeExtraSpace(itm['name']) == context.$_utilitySer.removeExtraSpace(searchText));
                        };

                        //to add new item in the options
                        field['addNewItemInList'] = function(searchText){
                            let isValidItem = true;
                            let msg = "Must match format: Month Year - Month Year";
                            if(!!searchText && searchText.trim() != "" && !field['dynamicDataLoading']) {
                                field['dynamicDataLoading'] = true;
                                if (field.title == "IEP Year") {
                                    var iepYearArr = searchText.split('-');
                                    if (iepYearArr.length == 2) {
                                        if (!context.moment(iepYearArr[0].trim(), "MMMM YYYY", true).isValid() || !context.moment(iepYearArr[1].trim(), "MMMM YYYY", true).isValid()) {
                                            isValidItem = false;
                                            setTimeout(function () {
                                                field['dynamicDataLoading'] = false;
                                                angular.element('.ui-select-search').trigger('focus');
                                                context.$_snack.showErrorToastr({message: msg});
                                            }, 100);
                                        } else {
                                            searchText = context.$_utilitySer.toTitleCase(iepYearArr[0].trim()) + " - " + context.$_utilitySer.toTitleCase(iepYearArr[1].trim());
                                        }
                                    } else {
                                        isValidItem = false;
                                        setTimeout(function () {
                                            field['dynamicDataLoading'] = false;
                                            angular.element('.ui-select-search').trigger('focus');
                                            context.$_snack.showErrorToastr({message: msg});
                                        }, 100);
                                    }
                                }
                                if (isValidItem) {
                                    var dependency, parentId;
                                    if (!!field['dependencies'] && field['dependencies'].length > 0) {
                                        dependency = field['dependencies'].find(d => d.dependType == 'filterOptions');
                                        if (!!dependency) {
                                            parentId = context.parsedModel[dependency['dependsOn']];
                                        }
                                    }
                                    let reqObj = {
                                        type: field['dynamicData'],
                                        data: searchText,
                                        parentId: parentId,
                                        subjectId: context.subjectId
                                    };

                                    if (!!field.metadata) {
                                        setFieldMetadata(searchText, reqObj);
                                    } else {
                                        context.$_api.saveFormDynamicAttribute(reqObj).then((s) => {
                                                context.parsedModel[field.key[0]] = s.id;
                                                field['options'].push({
                                                    id: s.id,
                                                    name: s.value,
                                                    parentId: s.parentId
                                                });
                                                field['dynamicDataLoading'] = false;
                                                ($('.ui-select-container.open').scope() as any).$select.open = false;
                                                field['dataName'] = s.value;
                                                resetAllDependencies(field);
                                            },
                                            (e) => {
                                                field['dynamicDataLoading'] = false;
                                                console.log(e);
                                            });
                                    }

                                }
                            }

                        }

                        //Handled the enter key press event
                        field['addCustomItem'] = function(event,searchText, items){
                            if (event.keyCode == 13 && !!searchText) {
                                var itemExist = items.find(function (item) {
                                    return context.$_utilitySer.removeExtraSpace(item.name) == context.$_utilitySer.removeExtraSpace(searchText);
                                });

                                if (!itemExist) {
                                    field.addNewItemInList(searchText);
                                }
                            }
                        }
                    }

                }
                if(field.type == FIELD_TYPE.FILE_UPLOAD){
                    field['displayFor'] = FORMS_MODULE;
                    field['navigateToDoc'] = (docId) => {
                        if(!!docId) {
                            this.$state.go('documents-load', { action: 'view-document', stateParams: { documentId: docId } }, { reload: true });
                        } else {
                            toastr.success("You do not have access to this Document.");
                        }
                    };

                    if(!field['documents']){
                        field['documents'] = [];
                    }
                    field['callback'] = () => {
                        $('.parent-div-' + field.key[0]).removeClass('req-fld-div');
                        if($('#parent-'+ field.key[0]).hasClass('has-error')) {
                            context.$scope.$broadcast('schemaForm.error.' + field.key[0], 'tv4-302', true);
                        }
                    }
                }
                if (!!field['dependencies'] && field['dependencies'].length > 0) {

                    let depArr = [];
                    field['dependencies'].forEach(dependency => {
                        //To filter the options in dropdown depending on the value selected in another dropdown
                        if (_.includes(['filterOptions', 'optionsNotIn', 'setValue', 'filterOptionsInArrayField', 'multipleFilterOptionsNotEqualTo'], dependency.dependType)) {
                            if (field.type == FIELD_TYPE.DYN_UI_SELECT) {
                                field['resetOnLoad'] = function () {
                                    if (!!field && !!field.options && !!field['fldConfig']) {
                                        let filteredOpts = field.options.filter(field.filterFunc);
                                        field['fldConfig']['ddOptions'] = filteredOpts;
                                        field['fldConfig']['value'] = null;
                                    }
                                }
                            }
                            if (dependency.dependType == 'filterOptions') {
                                field['filterFunc'] = function (item) {
                                    return item[dependency['dependValue']] == context.parsedModel[dependency['dependsOn']];
                                }
                            }
                            if (dependency.dependType == 'optionsNotIn') {
                                field['filterFunc'] = function (item) {
                                    let depVal = jsonLogic.apply(JSON.parse(dependency['dependsOn']), context.parsedModel);
                                    return !_.includes(depVal, item[dependency['dependValue']]);
                                }
                            }
                            if (dependency.dependType == 'filterOptionsInArrayField') {
                                if(dependency['dependValueSource'] && dependency['dependValueTarget']){
                                    //To filter options based on attributes other than id and parentId.
                                    field['arrayFilterFunc'] = function (tableIndex) {
                                        return function(item) {
                                            let parent = _.replace(dependency['scopeVar'],'tableIndex',tableIndex);
                                            let modelValue = _.get(context, parent);
                                            if(modelValue){
                                                return item[dependency['dependValueSource']] == modelValue[dependency['dependValueTarget']]
                                            } else {
                                                return false;
                                            }
                                        }
                                    }
                                } else{
                                    field['arrayFilterFunc'] = function (tableIndex) {
                                        return function(item) {
                                            let parent = _.replace(dependency['dependsOn'],'tableIndex',tableIndex);
                                            return item[dependency['dependValue']] == _.get(context.parsedModel, parent);
                                        }
                                    }
                                }
                            }
                            if (dependency.dependType == 'multipleFilterOptionsNotEqualTo') {
                                field['filterFunc'] = function (item) {
                                    let depOn = dependency['dependsOn'].split(',');
                                    let depVal = [];
                                    depOn.forEach(d => {
                                        let key = !!context.parsedFieldLabels[d]? context.parsedFieldLabels[d] : d;
                                        if (!!_.get(context.parsedModel, key)) {
                                            depVal.push(_.get(context.parsedModel, key));
                                        }
                                    })
                                    return !_.includes(depVal, item[dependency['dependValue']]);
                                }
                            }
                            if(!_.includes(dependency.dependType, 'multiple') && dependency.dependType != 'optionsNotIn'){
                                let dep = {
                                    "key": field['key'],
                                    "dependType": dependency.dependType,
                                    "dependValue": dependency.dependValue
                                }
                                let pfld = dependency['dependsOn'];
                                if (!!context.parsedDependencies[pfld]) {
                                    context.parsedDependencies[pfld].push(dep);
                                } else {
                                    context.parsedDependencies[pfld] = [dep];
                                }

                                field['readonlyOrParentEmpty'] = this.formConfig.readOnly + " || " + field['readonly'] + " || !model." + pfld;
                                field['disable'] = "!model." + pfld;
                            }

                        } else if (dependency.dependType == 'filterOptionsExternal') {
                            field['filterFunc'] = function (item) {
                                return item[dependency['dependValue']] == context.depModel['dependsOn'];
                            }
                        } else {
                            let str = this.getCndStr(dependency);
                            if (!!str) {
                                depArr.push(str);
                            }
                        }
                    });
                    !!field['condition'] && (depArr.push(field['condition']));
                    field['condition'] = depArr.join(' && ');
                }

                return field;
            }

            this.parseFieldSchema = (field: any) => {
                var tempFieldSchema = {
                    id: field.key,
                    title: !!field.title ? field.title : '',
                    label: field.label,
                    type: this.convertToSchemaFieldType(field.type, field.displayOptions),
                    valueType: field['type']
                };
                if (!!field.fieldOptions) {
                    var tempFieldFormat = this.getSchemaFieldFormat(field.fieldOptions.type);
                    (!!tempFieldFormat) && (tempFieldSchema['format'] = tempFieldFormat);
                    (!!field.fieldOptions.minLength && +field.fieldOptions.minLength >= 0) && (tempFieldSchema['minLength'] = field.fieldOptions.minLength);
                    (!!field.fieldOptions.maxLength && +field.fieldOptions.maxLength >= 0 && !!field.displayOptions && field.displayOptions.inputType != FIELD_TYPE.RTF_TEXTAREA) && (tempFieldSchema['maxLength'] = field.fieldOptions.maxLength);
                    (!!field.fieldOptions.maxFiles && field.fieldOptions.maxFiles >= 0) && (tempFieldSchema['maxFiles'] = field.fieldOptions.maxFiles);
                    (!!field.fieldOptions.interval) && (tempFieldSchema['multipleOf'] = field.fieldOptions.interval);
                    +field.fieldOptions.minValue >= 0 && (tempFieldSchema['minimum'] = field.fieldOptions.minValue);
                    +field.fieldOptions.maxValue >= 0 && (tempFieldSchema['maximum'] = field.fieldOptions.maxValue);
                    if (field.type == "scale" || !!field.fieldOptions.scaleLabels) {
                        var e = [];
                        var scaleLabels = field.fieldOptions.scaleLabels;
                        if (typeof (scaleLabels) == "string") {
                            scaleLabels = JSON.parse(scaleLabels);
                        }
                        for (var s in scaleLabels) {
                            e.push(parseInt(s));
                        }
                        tempFieldSchema['enum'] = e;
                    }

                    if (field.type == "array" || !!field.fieldOptions.valueLabels) {
                        var e = [];
                        var valueLabels = field.fieldOptions.valueLabels;
                        for (var s in valueLabels) {
                            e.push(parseInt(s));
                        }
                        tempFieldSchema['items'] = {
                            type: "number",
                            enum: e
                        };
                    }

                    if (field.type == FIELD_TYPE.CHECKBOX && field.fieldOptions.inputType == 'number'){
                        tempFieldSchema['valueType'] = 'number';
                    }
                }
                if (field.displayOptions && field.displayOptions.inputType == FIELD_TYPE.TEXTAREA) {
                    tempFieldSchema['valueType'] = FIELD_TYPE.TEXTAREA;
                }
                if (field['type'] == FIELD_TYPE.COMPOSITE_LIST || field['type'] == FIELD_TYPE.COMPOSITE) {
                    var itms = field.fields;
                    var items = {
                        type: "object",
                        properties: {}
                    };
                    for (var i = 0; i < itms.length; i++) {
                        let schm = _.cloneDeep(this.parsedSchema["properties"][itms[i]["key"]]);
                        if (schm) {
                            schm.subField = false;
                            items.properties[itms[i]['altKey']] = schm;
                        }
                    }
                    tempFieldSchema['items'] = items;
                    //tempFieldSchema['maxItems'] = 2;
                    tempFieldSchema['valueType'] = field['type'];
                }

                if (field['type'] == FIELD_TYPE.TABLE) {
                    var cols = field.fieldOptions.cols;
                    var items = {
                        type: "object",
                        properties: {}
                    };
                    for (var i = 0 ; i < cols.length; i++) {
                        let schm = _.cloneDeep(this.parsedSchema["properties"][field.key + '[].' + cols[i].key]);
                        schm.subField = false;
                        items.properties[cols[i]['key']] = schm;
                    }
                    tempFieldSchema['items'] = items;
                }
                if (field['type'] == "fieldArray") {
                    var cols = field.fieldOptions.fieldItems;
                    var items = {
                        type: "object",
                        properties: {}
                    };
                    for (var i = 0 ; i < cols.length; i++) {
                        items.properties[cols[i]['key']] = {
                            title: cols[i]['fieldName'],
                            type: cols[i]['type']
                        }
                    }
                    tempFieldSchema['items'] = items;
                }
                switch (field['type']) {
                    case 'date':
                        tempFieldSchema['valueType'] = 'date';
                        break;
                    case FIELD_TYPE.TIME_PICKER:
                        tempFieldSchema['valueType'] = FIELD_TYPE.TIME_PICKER;
                        break;
                    case FIELD_TYPE.SIGNATURE:
                        tempFieldSchema['valueType'] = FIELD_TYPE.SIGNATURE;
                        this.signFlds.push(field.key);
                        break;
                    case FIELD_TYPE.DYN_UI_SELECT:
                        tempFieldSchema['valueType'] = FIELD_TYPE.DYN_UI_SELECT;
                        tempFieldSchema['items'] = {
                            type: "object"
                        };
                        break;
                    case FIELD_TYPE.USERS:
                        tempFieldSchema['valueType'] = FIELD_TYPE.USERS;
                        tempFieldSchema['items'] = {
                            type: "object"
                        };
                        break;
                    case 'list':
                        tempFieldSchema['valueType'] = FIELD_TYPE.UI_SELECT;
                        break;
                    case FIELD_TYPE.FILE_UPLOAD:
                        tempFieldSchema['valueType'] = FIELD_TYPE.FILE_UPLOAD;
                        tempFieldSchema['items'] = {
                            type: "object"
                        };
                        break;
                    default:
                        break;
                }

                tempFieldSchema['subField'] = !!field['subField'];

                return tempFieldSchema;
            }

            this.addSchema = (schema: any, fieldKey: string) => {
                this.parsedSchema.properties[fieldKey] = schema;
            }

            this.parseSignature = (formSignature: any) => {
                this.parsedSignature['consent'] = formSignature.isSigned == 1? true:false;
                this.parsedSignature['signedBy'] = formSignature.signedBy;
            }

            this.parseModel = (field: any, parsedFieldSchema: any, parsedField: any) => {
                let deferred = this.$q.defer();
                let key = parsedField['key'];
                try {
                    var processAnswer = (parsedFieldSchema: any, answer: any, fld?: any, parsedField?: any) => {
                        let deferred = this.$q.defer();
                        let result = answer;
                        if ((!Array.isArray(answer) || answer.length > 0)) {
                            if(fld['type'] == FIELD_TYPE.DYN_UI_SELECT){
                                let ans = answer;
                                if (parsedFieldSchema.type == "number") {
                                    ans =  parseFloat(answer);
                                } else if (parsedFieldSchema.type == "array") {
                                    ans =  Array.isArray(answer)? answer : JSON.parse(answer);
                                }

                                if(parsedField.fldConfig){
                                    if(parsedField.fldConfig.ddOptions){
                                        let res = parsedField.fldConfig.ddOptions;
                                        if (fld.displayOptions.inputType == 'single-select') {
                                            parsedField['fldConfig']['value'] = res.find(r => r.id == ans);
                                        } else {
                                            parsedField['fldConfig']['value'] = _.map(ans, u => {
                                                let usr;
                                                if(typeof(u) == 'number') {
                                                    usr = res.find(r => r.id == u);
                                                    if (!!usr) {
                                                        return usr;
                                                    } else {
                                                        return u;
                                                    }
                                                } else {
                                                    usr = res.find(r => r.id == u.id);
                                                    if (!!usr) {
                                                        return usr;
                                                    } else {
                                                        return !!parsedField.fldConfig.apiConfig['respMdl'] ? new RespModel[parsedField.fldConfig.apiConfig['respMdl']]().deserialize(u) : u;
                                                    }
                                                }
                                            });
                                        }
                                    } else {
                                        fld.valueId = ans;
                                    }
                                } else {
                                    fld.valueId = ans;
                                }
                                deferred.resolve(ans);
                            } else if (parsedFieldSchema.type == "number") {
                                deferred.resolve(parseFloat(answer));
                            } else if (parsedFieldSchema.type == "integer") {
                                deferred.resolve(parseInt(answer));
                            } else if (parsedFieldSchema.type == "date") {
                                deferred.resolve(Util.getNonUTCDate(parseFloat(answer)));
                            } else if (parsedFieldSchema.type == "time") {
                                if(this.formConfig.readOnly){
                                    result = Util.getNonUTCTime(parseFloat(answer), (fld.fieldOptions.format == "12-hour"));
                                } else {
                                    result = Util.getNonUTCDateTime(parseFloat(answer));
                                }
                                deferred.resolve(result);
                            } else if (parsedFieldSchema['valueType'] == FIELD_TYPE.TEXTAREA) {
                                deferred.resolve(answer.replace(/<\/br\/?>/gi, '\r\n'));
                            } else if(parsedFieldSchema['valueType'] == FIELD_TYPE.HYPERLINK) {
                                answer = Util.isJsonString(answer)? JSON.parse(answer) : answer;
                                answer.config = fld.fieldOptions.configs.find(c => c.template == answer.template);
                                deferred.resolve(answer);
                            } else if (parsedFieldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST) {
                                answer = Util.isJsonString(answer)? JSON.parse(answer) : answer;
                                let items = parsedFieldSchema['items']['properties'];
                                let prmArr = [];
                                answer.forEach(ans => {
                                    if(!!fld.fieldOptions && fld.fieldOptions.hideAnswers && !!ans['id']){
                                        ans.hideAnswer = true;
                                    }
                                    Object.keys(items).forEach(k => {
                                        if (ans[k] != null && ans[k] != undefined) {
                                            let subFld = fld.fields.find(f => f.altKey == k);
                                            let parsedSubFld = parsedField.items.find(f => f.altKey == k);
                                            prmArr.push(processAnswer(items[k], ans[k], subFld,parsedSubFld).then(rs => {
                                                ans[k] = rs;
                                            }));
                                        }
                                    });
                                })
                                this.$q.all(prmArr).then(() => {
                                    deferred.resolve(answer);
                                });
                            } else if (parsedFieldSchema['valueType'] == FIELD_TYPE.COMPOSITE) {
                                answer = Util.isJsonString(answer)? JSON.parse(answer) : answer;
                                let items = parsedFieldSchema['items']['properties'];
                                let prmArr = [];
                                Object.keys(items).forEach(k => {
                                    if (answer[k] != null && answer[k] != undefined) {
                                        let subFld = fld.fields.find(f => f.altKey == k);
                                        let parsedSubFld = parsedField.items.find(f => f.altKey == k);
                                        prmArr.push(processAnswer(items[k], answer[k], subFld,parsedSubFld).then(rs => {
                                            answer[k] = rs;
                                            //return;
                                        }))
                                    }
                                });
                                this.$q.all(prmArr).then(() => {
                                    deferred.resolve(answer);
                                });
                            }
                            else if (parsedFieldSchema['valueType'] == FIELD_TYPE.SUBJECTS) {
                                if(fld.displayOptions.inputType == 'single-select'){
                                    this.SubjectService.getSubjectById(answer).then(s =>{
                                        deferred.resolve(s);
                                    });
                                } else {
                                    let prmArr = [];
                                    let mdl =[];
                                    answer.forEach(ans => {
                                        prmArr.push(this.SubjectService.getSubjectById(ans).then(s =>{
                                            mdl.push(s);
                                        }));
                                    })
                                    this.$q.all(prmArr).then(() => {
                                        deferred.resolve(mdl);
                                    });
                                }
                            }
                            else if (parsedFieldSchema['valueType'] == FIELD_TYPE.USERS) {
                                this.$_api.getUsersById([answer]).then(s =>{
                                    if(fld.displayOptions.inputType == 'single-select'){
                                        deferred.resolve(s.users[0]);
                                    } else {
                                        deferred.resolve(s.users);
                                    }
                                });
                            }
                            else if (parsedFieldSchema['type'] == 'boolean' && parsedFieldSchema['valueType'] == 'number') {
                                deferred.resolve(!!answer);
                            }else if (parsedFieldSchema['type'] == "array") {
                                answer = Array.isArray(answer)? answer : JSON.parse(answer);
                                deferred.resolve(answer);
                            } else if (fld.type == FIELD_TYPE.FILE_UPLOAD) {
                                let ans = Array.isArray(answer)? answer : JSON.parse(answer);
                                let files = [];
                                let documents = [];
                                /*
                                    Here ans can be either of these types
                                    ["filename1.ext","filename2.ext"] or
                                    [{"fileName": "filename1.ext", "documentId": 123},{"fileName": "filename2.ext", "documentId": 456}]
                                */
                                var docs = Array.isArray(fld.uploadedDocs) ? fld.uploadedDocs : [];
                                for (let i = 0; i < ans.length; i++) {
                                    let fn = !!ans[i].fileName? ans[i].fileName : ans[i];
                                    let uplId = i + '-' + new Date().getTime();
                                    let ext = this.$_com.getExtension(fn.toLowerCase());
                                    let index = docs.findIndex(d => d.fileName === fn); // this requires to be case sensitive comparision
                                    let doc = [];
                                    let document = new Document();
                                    if (index > -1) {
                                        doc = docs.splice(index, 1);
                                    }
                                    let file = {
                                        "uplId": uplId,
                                        "fullFilename": fn,
                                        "filename": fn.slice(0, ((ext.length + 1) * (-1))),
                                        "extension": ext,
                                        "documentId": (doc.length > 0 ? doc[0].documentId : (ans[i].documentId? ans[i].documentId : 0))
                                    };
                                    files.push(file);
                                    document['displayedFileName'] = file.filename;
                                    document['extension'] = file.extension;
                                    document['docFile'] = file;
                                    document['uplId'] = file.uplId;
                                    !!ans[i].title && (document['title'] = ans[i].title);
                                    !!ans[i].folderName && (document['folderName'] = ans[i].folderName);
                                    documents.push(document);
                                }
                                deferred.resolve({ filenames: files, documents: documents });
                            }else if (parsedFieldSchema['type'] == "object") {
                                deferred.resolve(Util.isJsonString(answer)? JSON.parse(answer) : answer);
                            }else if (fld.type == FIELD_TYPE.PHONE_NUMBER) {
                                let ans = fld.answer;
                                if(typeof ans == 'string'){
                                    let ind = ans.indexOf(" Ext.");
                                    if(ind != -1) {
                                        this.parsedModel[key + '-' + FIELD_TYPE.PHONE] = ans.substring(0, ind);
                                        this.parsedModel[key + '-' + FIELD_TYPE.EXT] = ans.substring(ind + 3);
                                    } else {
                                        this.parsedModel[key + '-' + FIELD_TYPE.PHONE] = ans;
                                    }
                                } else {
                                    if(ans['phone']) {
                                        this.parsedModel[key + '-' + FIELD_TYPE.PHONE] = ans['phone'];
                                    }
                                    if(ans['extension']) {
                                        this.parsedModel[key + '-' + FIELD_TYPE.EXT] = ans['extension'];
                                    }
                                }
                                deferred.resolve(result);
                            } else {
                                deferred.resolve(result);
                            }
                        } else {
                            deferred.resolve(result);
                        }

                        return deferred.promise;
                    }
                    if (field.answer != null && field.answer != undefined && field.type != FIELD_TYPE.TABLE) {
                        processAnswer(parsedFieldSchema, field.answer, field, parsedField).then(rs => {
                            if(field.fieldOptions.deferModel){  //Defer setting the model of the field. In case if dropdowns the model can be set after the list options are avaialble.
                                this.deferredModel[key] = rs;
                            } else {
                                this.parsedModel[key] = rs;
                            }
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }

                    if (field.type == FIELD_TYPE.TABLE) {
                        var cols = field.fieldOptions.cols;
                        var data = field.fieldOptions.data;
                        var ignoreRow = field.fieldOptions.ignoreRow;
                        var tableData = [];
                        var row = [];
                        let counter = 0;
                        var parsedData = [];
                        if (!!field.answer) {
                            parsedData = Util.isJsonString(field.answer)? JSON.parse(field.answer) : field.answer ;
                            //Support for new counter////
                            parsedData.forEach((p) => {
                                if (!!p['counterArray'] && !!p['counterArray']['counter']) {
                                    let cntrs = Object.keys(p['counterArray']['counter']);
                                    if (!_.includes(cntrs, 'model')) {
                                        p['counterArray']["counter"]["model"] = {val: "0"};
                                    }
                                }
                            });
                            //////////////
                        } else if(!!data) {
                            parsedData = data;
                        }
                        // This code block will be needed for counter array fields
                        if (!!field.fieldOptions.fieldConfigurations) {
                            var fieldConfigurations = field.fieldOptions.fieldConfigurations;
                            for (let config of fieldConfigurations) {
                                if (config.option == "Trial Count") {
                                    this.fieldConfigurationsData.push(config);
                                }
                            }
                        }

                        let items = parsedFieldSchema['items']['properties'];
                        let prmArr = [];
                        parsedData.forEach(ans => {
                            Object.keys(items).forEach(k => {
                                let col = cols.find(f => f.key == k);
                                let itemKey = (col.valueKey? col.valueKey: col.key);
                                let itemVal = _.get(ans, itemKey);
                                if (itemVal != null && itemVal != undefined) {
                                    prmArr.push(processAnswer(items[k], itemVal, col).then(rs => {
                                        ans[k] =  rs;
                                    }));
                                } else {
                                    ans[k] = null;
                                }
                            });
                        });

                        let ignoreRowCount = 0
                        ////////////
                        this.$q.all(prmArr).then(() => {
                            for (let item of parsedData) {
                                counter++;
                                row = [];
                                if(!!ignoreRow && item[ignoreRow.key] == ignoreRow.value){
                                    item.hide = true
                                    ignoreRowCount++
                                }
                                var cell = _.cloneDeep(item);
                                var filledCols = cols.length;
                                for (let col of cols) {
                                    if (!item.hasOwnProperty(col.key)) {
                                        if (col.type == "boolean") {
                                            cell[col.key] = false;
                                        } else {
                                            cell[col.key] = null;
                                        }
                                    }
                                    if (cell[col.key] == null || cell[col.key] == '') {
                                        filledCols--;
                                    }
                                }
                                // !cell['id'] && (cell['id'] = counter);
                                //For readonly forms no need to show the empty rows
                                if (!this.formConfig.readOnly || filledCols > 0) {
                                    tableData.push(cell);
                                }
                            }
                            if(!!ignoreRow) field.fieldOptions.ignoreRow.allResolved =  _.isEqual(parsedData.length,ignoreRowCount)
                            //For readonly forms if whole table is empty then add just one empty row
                            if (this.formConfig.readOnly && tableData.length == 0) {
                                for (let col of cols) {
                                    cell[col.key] = null;
                                }
                                // cell['id'] = 1;
                                tableData.push(cell);
                            }
                            this.parsedModel[field.key] = tableData;
                            deferred.resolve();
                        });

                    }
                } catch (e) {
                    if (this.FormService.ecareEnv != 'my') {
                        //For debugging purpose in non-production env
                        console.log("Error while parsing model: ", field.answer);
                    }
                    console.log("Error: ", e);
                    deferred.reject();
                }
                return deferred.promise;
            }

            this.canUsrEdit = (fldRoles) => {
                let canEdit = true;
                if(fldRoles && this.formUsers && this.formUsers.length > 0){
                    let crntUsrRoles = this.formUsers.filter(fu => fu.userId == this.currentUser.userId && _.includes(fldRoles,fu.role));
                    if(crntUsrRoles.length == 0){
                        canEdit = false;
                    }
                }
                return canEdit;
            }

            this.setDefaultFieldValue = (field: any, postParse?) => {
                let def = field.fieldOptions.default;
                let ans = postParse? this.parsedModel[field.key] : field['answer'];
                switch(field.type) {
                    case FIELD_TYPE.TIME_PICKER:
                        if(!!def['web']) {
                            let dt = eval(def['web']);
                            ans = Util.getUTCDateTime(dt);
                        }
                        break;
                    case FIELD_TYPE.DATE:
                        let dt = eval(def);
                        ans = Util.getUTCTime(dt);
                        break;
                    case FIELD_TYPE.SCALE:
                    case FIELD_TYPE.NUMBER:
                        ans = eval(def);
                        break;
                    case FIELD_TYPE.COMPOSITE_LIST:
                    case FIELD_TYPE.TABLE:
                        if(ans) {
                            ans.forEach(o => {
                                Object.keys(def).forEach(k => {
                                    if(!o[k]) {
                                        o[k] = def[k];
                                    }
                                })
                            });
                        } else if (!!field.fieldOptions.startWithBlankForm) {
                            let obj = {};
                            Object.keys(def).forEach(k => {
                                if(!obj[k]) {
                                    obj[k] = def[k];
                                }
                            })
                            ans = [obj];
                        }
                        break;
                    default:
                        ans = def;
                }
                if(postParse){
                    this.parsedModel[field.key] = ans;
                } else {
                    field['answer'] = ans;
                }
            }

            this.autofill = (field, postParse = false) => {
                var deferred = this.$q.defer();
                var fillField = (autoFillEntity, obj) => {
                    var answer;
                    if (autoFillEntity.sourceField == "age") {
                        let dob = new Date(obj.birthDate);
                        var now = new Date;
                        var dur = this.moment.duration({from: dob, to: now});
                        answer = Math.floor(dur.asYears());
                    } else {
                        answer = _.get(obj, autoFillEntity.sourceField);
                    }

                    if(field.type == FIELD_TYPE.COMPOSITE && !!autoFillEntity.targetSubField){
                        _.set(field['answer'], autoFillEntity.targetSubField, answer);
                    }else  if(field.type == FIELD_TYPE.COMPOSITE_LIST && !!autoFillEntity.targetSubField){
                        let ans = {};
                        _.set(ans, autoFillEntity.targetSubField, answer);
                        let processAnswer;
                        //post process, set the answer to the model.
                        postParse && this.parsedModel[field.key] && (processAnswer = this.parsedModel[field.key]);

                        //otherwise set the answer to the field directly.
                        if(!postParse && field['answer']){
                            field['answer'] = Util.isJsonString(field['answer'])? JSON.parse(field['answer']) : field['answer'];
                            processAnswer = field['answer'];
                            field['answer'].length == 0 && (field['answer'].push(ans));
                        }

                        //to autofill fields of existing object in composite list
                        processAnswer && (processAnswer.forEach(m =>{
                            if(!m[autoFillEntity.targetSubField]){
                                m[autoFillEntity.targetSubField] = answer;
                            }
                        }));
                    } else if(field.type == 'list'){
                        let prntAns,depVal;
                        if(!!field.dependencies){
                            let dep = field.dependencies.find(d => d.dependType == 'filterOptions');
                            if(!!dep){
                                depVal = dep['dependValue'];
                                prntAns = this.parsedModel[dep['dependsOn']];
                            }
                        }
                        let listOpts = field.fieldOptions["listOptions"];
                        let def = listOpts.find(opt => ((!prntAns || opt[depVal] == prntAns) && opt['label'].toLowerCase() == (answer+"").toLowerCase()) || opt['id'] == answer);
                        if(!!def){
                            field['answer'] = def.id;
                        }
                    } else {
                        field['answer'] = answer;
                    }
                }


                //////////////////////////
                //If user cannot edit the field then no need to send the answer
                !this.canUsrEdit(field.roles) && (this.skipFields.push(field.key));

                field.type == FIELD_TYPE.COMPOSITE && (field['answer'] = {});
                field.type == FIELD_TYPE.COMPOSITE_LIST && !field['answer'] && (field['answer'] = []);
                for (let autoFillEntity of field.displayOptions.autoFill) {
                    if (autoFillEntity.entity == "teamMember" && field.fieldOptions.hasOwnProperty("listOptions")) {
                        var listOptions = [];
                        var promise1 = this.$_api.getTeamMembers(this.subjectId).then(
                            (s) => {
                                let fieldVaule = "";
                                for (let member of s) {
                                    fieldVaule = member[autoFillEntity.field];

                                    listOptions.push({
                                        "id": member.id,
                                        "label": fieldVaule
                                    });
                                }

                                field.fieldOptions["listOptions"] = listOptions;
                            }
                        );
                        //promiseAry.push(promise1);
                    }else if (autoFillEntity.entity == "team") {
                        fillField(autoFillEntity, this.subject);
                    } else if (autoFillEntity.entity == "student") {
                        let stu = this.subject.teams[0];
                        fillField(autoFillEntity, stu);
                    } else if (autoFillEntity.entity == "customAttr" && !!this.subject.customAttributes) {
                        fillField(autoFillEntity, this.subject.customAttributes);
                    } else if (autoFillEntity.entity == "selectedTeamCustomAttr" && !!this.selectedSubject && !!this.selectedSubject.customAttributes) {
                        fillField(autoFillEntity, this.selectedSubject.customAttributes);
                    } else if (autoFillEntity.entity == "user") {
                        fillField(autoFillEntity, this.currentUser);
                    } else if (autoFillEntity.entity == "autofillObj") {
                        fillField(autoFillEntity, this.autofillObj);
                    } else if (autoFillEntity.entity == "default_listOptions") {
                        let listOpts = field.fieldOptions["listOptions"];
                        let def = listOpts.find(opt => opt[autoFillEntity.sourceField] == autoFillEntity.value);
                        if(!!def){
                            field['answer'] = def.id;
                        }
                    } else if (autoFillEntity.entity == "serviceType" && !!this.service && field.fieldOptions.hasOwnProperty("listOptions")) {
                        let listOpts = field.fieldOptions["listOptions"];
                        let def = listOpts.find(opt => opt[autoFillEntity.field].toUpperCase() == this.service.serviceType.toUpperCase());
                        if(!!def){
                            field['answer'] = def.id;
                        }
                    } else if(autoFillEntity.entity == "formModel") {
                        fillField(autoFillEntity, this.parsedModel);
                    }
                }
                if(promise1){
                    promise1.then(data => {
                        deferred.resolve();
                    })
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }

            this.fetchValueSource = (actn, result) => {
                let data = {};
                if(actn['valueSource']){
                    for(let vs of actn['valueSource']){
                        switch (vs['type']){
                            case ValueSourceTypeEnum.FIELD_VALUE:
                                data = _.reduce(vs['var'], (obj,v) => {
                                    let key = !!this.parsedFieldLabels[v]? this.parsedFieldLabels[v] : v;
                                    let val = this.parsedModel[key];
                                    (!!val || val == 0) && (obj[v] = val);
                                    return obj;
                                }, data);
                                break;
                            case ValueSourceTypeEnum.SCOPE_VAR:
                                data = _.reduce(vs['var'], (obj,v) => {
                                    let val = this[v];
                                    (!!val || val == 0) && (obj[v] = val);
                                    return obj;
                                }, data);
                                break;
                            case ValueSourceTypeEnum.SELECTED_VALUE:
                                data = _.reduce(vs['var'], (obj,v) => {
                                    let key = !!this.parsedFieldLabels[v]? this.parsedFieldLabels[v] : v;
                                    let val = this.fetchField(this.parsedForm, null, key);
                                    if(!!val){
                                        _.set(obj, v, val.fldConfig.value);
                                    }
                                    return obj;
                                }, data);
                                break;
                            case ValueSourceTypeEnum.OPERATION:
                                var ops = {
                                    "roundDecimal" : (num,digits) => {
                                        return parseFloat(Number(num).toFixed(digits));
                                    },
                                    "fetchArray" : (rule) => {
                                        return jsonLogic.apply(JSON.parse(rule), this.parsedModel);
                                    }
                                };
                                vs['var'].forEach(v => {
                                    (!!ops[v] && typeof ops[v] == "function") && (jsonLogic.add_operation(v, ops[v]));
                                });
                                break;
                            case "result":
                                data['result'] = result;
                        }
                    }
                }
                return data;
            };

            this.fldOnChange = (action, result, index = null) => {
                var deferred = this.$q.defer();
                var setResult = (params) => {
                    if (typeof params == 'object') {
                        for (let p in params) {
                            params[p] = setResult(params[p]);
                        }
                    } else if (typeof params == 'string') { // Single check for if params is a String
                        // Check if the string contains any of the following: ${_result_}, ${_tableIndex_}, ${_[interpolated field name]_}
                        if (_.includes(params, '${_result_}')) {
                            params = _.replace(params, '${_result_}', result);
                        }

                        if (_.includes(params, '${_tableIndex_}')) {
                            params = _.replace(params, '${_tableIndex_}', index);
                            let keys = params.split('.'); // Split the string by '.' to get the keys
                            keys[0] = !!this.parsedFieldLabels[keys[0]] ? this.parsedFieldLabels[keys[0]] : keys[0]; // Replace the first key with the parsed field label
                            params = keys.join('.'); // Join the keys back with '.' and assign it to params
                        }

                        let regex = /\${_((?!tableIndex|result)[a-zA-Z]+)_}/; // match the string with ${_[interpolated field name]_} but not ${_tableIndex_} and ${_result_}
                        let match = params.match(regex); // match the string with the regex

                        // If there is a match, replace the string with the value of the field
                        if (match) {
                            params = _.replace(params, regex, this.parsedModel[this.parsedFieldLabels[match[1]]]);
                        }

                        regex = /\${_fldLbl\[([a-zA-Z]+)\]_}/; /// match string ${_fldLbl[interpolated field name]_}
                        match = params.match(regex);
                        if(match) {
                            params = _.replace(params, regex, this.parsedFieldLabels[match[1]]);
                        }
                    }

                    return params;
                }
                Object.keys(action).forEach((k) => {
                    switch (k) {
                        case FieldOperationEnum.SET:
                            for(let actn of action[k]){
                                actn['field'] = !!this.parsedFieldLabels[actn['field']]? this.parsedFieldLabels[actn['field']] : actn['field'];
                                let data = this.fetchValueSource(actn, result);
                                let cndtn = actn['condition']? setResult(actn['condition']) : null;
                                if (!cndtn || jsonLogic.apply(cndtn, data)) {
                                    switch (actn['type']) {
                                        case SetTypeEnum.FIELD_VALUE:
                                            if (!!actn['rule']) {
                                                let fieldPath = setResult(_.cloneDeep(actn['field']));
                                                let rule = setResult(_.cloneDeep(actn['rule']));
                                                _.set(this.parsedModel, fieldPath, jsonLogic.apply(rule, data));
                                            }
                                            break;
                                        case SetTypeEnum.SCOPE_VAR:
                                            if (!!actn['rule']) {
                                                let field = setResult(_.cloneDeep(actn['field']));
                                                let rule = setResult(_.cloneDeep(actn['rule']));
                                                let setVal = () => {
                                                    if (!!actn['fieldPath']) {
                                                        let fieldPath = setResult(_.cloneDeep(actn['fieldPath']));
                                                        _.set(this[field], fieldPath, jsonLogic.apply(rule, data))
                                                    } else {
                                                        this[field] = jsonLogic.apply(rule, data);
                                                    }
                                                }
                                                if(!!actn['delay']) {
                                                    setTimeout(() => {
                                                        setVal();
                                                    }, actn['delay']);
                                                } else {
                                                    setVal();
                                                }
                                            }
                                            break;
                                        case SetTypeEnum.ATTRIBUTE:
                                            if (!!actn['rule']) {
                                                let fld = this.fetchField(this.parsedForm, null, actn['field']);
                                                _.set(fld, actn['attr'], jsonLogic.apply(actn['rule'], data));
                                            }
                                            break;
                                        case 'array_field_value':
                                            let fld = this.fetchField(this.parsedForm, null, actn['field']);
                                            let fldVal = this.parsedModel[actn['field']];
                                            !fldVal && (fldVal = []);
                                            if (actn['source'] == "result") {
                                                this.parsedModel[actn['field']] = [...fldVal, ...result];
                                                !!fld['processNewObject'] && (fld['processNewObject'](actn['field']));
                                            } else if (!!actn['rule']) {
                                                this.parsedModel[actn['field']] = jsonLogic.apply(actn['rule'], data);
                                            }
                                            break;
                                    }
                                }
                            }
                            break;
                        case FieldOperationEnum.EXEC_ACTION:
                            for(let actn of action[k]){
                                actn['field'] = !!this.parsedFieldLabels[actn['field']]? this.parsedFieldLabels[actn['field']] : actn['field'];
                                let data = this.fetchValueSource(actn, result);
                                let cndtn = actn['condition']? setResult(actn['condition']) : null;
                                if (!cndtn || jsonLogic.apply(cndtn, data)) {
                                    switch (actn['type']) {
                                        case SetTypeEnum.ATTRIBUTE:
                                            let fld = this.fetchField(this.parsedForm, null, actn['field']);
                                            !!fld[actn['attr']] && typeof fld[actn['attr']] == "function" && (fld[actn['attr']]());
                                            break;
                                        case FieldEventTypeEnum.CALL_API:
                                            let actnCopy = _.cloneDeep(actn);
                                            actnCopy.params = setResult(actnCopy.params);
                                            let p = {
                                                "url": null,
                                                "method": null,
                                                "bodyParams": null,
                                                "queryParams": null
                                            };
                                            actnCopy.params = Object.assign(p,actnCopy.params);//to keep the order of attributes in params
                                            this.callService(this.APIService, actnCopy, index);
                                            break;
                                        case FieldEventTypeEnum.CALL_SERVICE:
                                            let actionCopy = _.cloneDeep(actn);
                                            actionCopy.params = setResult(actionCopy.params);
                                            actionCopy.params['result'] = result;
                                            this.callService(this, actionCopy, index);
                                            break;
                                    }
                                }
                            }
                            break;

                    }
                });
                deferred.resolve();
                return deferred.promise;
            };

            this.callService = (service, source, index=null) => {
                var deferred = this.$q.defer();
                if (typeof service[source.action] == "function") {
                    var actualCall = () => {
                        var dfrd = this.$q.defer();
                        var params = [];
                        var callFn = () => {
                            service[source.action](...params).then((res) => {
                                let resp = (!!res.data)? res.data : res;
                                if(source.respMdl){
                                    let result = [];
                                    for (var i = 0; i < resp.length; i++) {
                                        let temp = new RespModel[source['respMdl']]().deserialize(resp[i]);
                                        if (!!temp)
                                            result.push(temp);
                                    }
                                    resp = result;
                                }
                                !!source.cacheResp && this.$_cache.set(source.cacheResp,resp,true);
                                dfrd.resolve(resp);
                            }).catch((e) => {
                                dfrd.reject(e);
                            });
                        }
                        if (source.params) {
                            //extract param values
                            params = this.FieldService.UtilityService.getValuesFromObject(source.params);
                            params = this.FieldService.handleParams(params, this);
                        }
                        if(!!source.cacheResp) {
                            let rs = this.$_cache.get(source.cacheResp,true);
                            if(!!rs) {
                                dfrd.resolve(rs);
                            } else {
                                callFn();
                            }
                        } else {
                            callFn();
                        }


                        return dfrd.promise;
                    }

                    var hasPreProcess = (source.process && source.process[FieldProcessTypeEnum.PRE]);
                    var hasPostProcess = (source.process && source.process[FieldProcessTypeEnum.POST]);

                    var normalCall = () => {
                        actualCall().then((data) => {
                            if (hasPostProcess) {
                                this.handleProcess(source.process[FieldProcessTypeEnum.POST], data, index).then(() => {
                                    deferred.resolve(data);
                                })
                            }
                            else {
                                deferred.resolve(data);
                            }
                        }).catch(e => {
                            deferred.reject(e);
                        });
                    }

                    if (hasPreProcess) {
                        this.handleProcess(source.process[FieldProcessTypeEnum.PRE], index).then(() => {
                            normalCall();
                        })
                    } else {
                        normalCall();
                    }
                } else {
                    deferred.reject("Method named " + source.action + " not found in Cache.")
                }
                return deferred.promise;
            }

            this.handleProcess = (process: FieldProcess, result?, index?) => {
                var deferred = this.$q.defer();
                this.fldOnChange(process, result, index);

                deferred.resolve();
                return deferred.promise;
            }

            this.filterArray = (rule, result) => {
                var deferred = this.$q.defer();
                let resp = result.filter(v => jsonLogic.apply(rule, {v, model: this.parsedModel}));
                deferred.resolve(resp);
                return deferred.promise;
            }

            //This function is used for AAICAMA forms to check for duplicate ssn in the system
            this.checkSysDuplicate = (ind, res) => {
                //In case of manage child info ssn check should be done only if the updated ssn is not same as the original ssn
                if(!this.modelBak.subject || !this.modelBak.subject[ind] || this.modelBak.subject[ind].ssnId !=  res) {
                    this.APIService.callApi('/ssn/check', "POST", {"ssn": res}, null, API_TYPE.API).then(s => {
                        this.dupSysVal[ind] = s.ssnExists;
                    });
                }
            }

            //This function is used for AAICAMA forms to check for duplicate ssn in the form
            this.checkDuplicate = (arr, currentIndex, result) => {
                var deferred = this.$q.defer();
                let isDup = false;
                this.dupSysVal[currentIndex] = false;
                let val = arr[currentIndex];
                arr.forEach((o,i) => {
                    if(o == val && i != currentIndex){
                        this.dupVal[i] = true;
                        isDup = true;
                    } else if(o != val){
                        //if this value was initially a form duplicate and now its not then check for system duplicate.
                        if(this.dupVal[i]){
                            this.dupVal[i] = false;
                            arr[i] && (this.checkSysDuplicate(i, arr[i]));
                        }
                    }
                });
                if(isDup){
                    this.dupVal[currentIndex] = true;
                } else {
                    //if current value is not duplicated in form then check for system duplicate
                    this.dupVal[currentIndex] = false;
                    arr[currentIndex] && (this.checkSysDuplicate(currentIndex, arr[currentIndex]));
                }
                deferred.resolve(isDup);
                return deferred.promise;
            }

            this.mapArrays = (sArr, tArr, sAttr, tAttr) => {
                return _.map(sArr, (a) => {
                    return tArr.find(b => b[tAttr] == a[sAttr]);
                })
            }

            // Reduce an array to an object with the specified key being a property of the object to use as the actual object keys using lodash
            // can take more than one key as separate parameters, they will be concatenated with the colon character if more than one.
            // Example:
            // reduceArrayByProperties([{id: 1, name: 'John'}, {id: 2, name: 'Jane'}], 'id', 'name')
            // will return {"1:John": {id: 1, name: 'John'}, "2:Jane": {id: 2, name: 'Jane'}}
            // reduceArrayByProperties([{id: 1, name: 'John'}, {id: 2, name: 'Jane'}], 'id')


            this.reduceArrayByProperties = (arr, ...keys) => {
                return _.reduce(arr, (obj, item) => {
                    let key = keys.map(k => item[k]).join(':');
                    obj[key] = item;
                    return obj;
                }, {});
            }

            //Loop through array elements and add/update object of field with value
            //Example:addFieldInArrayObject([{"id":1},{"id":2,"roleId":3}],roleId,4)
            //will give output as [{"id":1,"roleId":4},{"id":2,"roleId":4}]
            this.addFieldInArrayObject = (arr,field,value) => {
                for (let obj of arr) {
                    obj[field] = value;
                }
                return arr;
            }

            this.parseField = (field: any) => {
                var context = this;
                !field.displayOptions && (field.displayOptions = {});
                !field.fieldOptions && (field.fieldOptions = {});
                if (field.displayOptions.inputType != 'label') {
                    this.fieldCounter += 1;
                    this.pendingParsedFields += 1;
                }
                //For servicenote
                if (this.formConfig.status == Util.FORM_STATUS.SUBMITTED && !!field.answer && !this.isReadOnly && !!field.fieldOptions && !!field.fieldOptions.resetOnEdit) {
                    field['answer'] = undefined;
                }

                if (this.canUsrEdit(field.roles) && (!!field.fieldOptions && !!field.fieldOptions["default"] && (_.includes([FIELD_TYPE.TABLE, FIELD_TYPE.COMPOSITE_LIST], field.type) || !field.hasOwnProperty("answer")))) {
                    this.autofilled.push(field.key);
                    this.setDefaultFieldValue(field);
                }

                var tempField = {};
                if(field['type'] == FIELD_TYPE.FILE_UPLOAD){
                    let rplStr = field.key.split('.').slice(-1)[0];
                    if(!!new RegExp(/^\d+$/).test(rplStr)){  //if field key is numeric
                        field.key = _.replace(field.key, rplStr, FIELD_TYPE.FILE_UPLOAD + rplStr);
                        !!field.altKey && (field.altKey = FIELD_TYPE.FILE_UPLOAD+field.altKey);
                    }
                    tempField['showDocDetails'] = !!field.fieldOptions.showDocDetails? field.fieldOptions.showDocDetails : null;
                    tempField['folderNames'] = !!field.fieldOptions.folderNames? field.fieldOptions.folderNames : null;
                }
                tempField['key'] = field.key;
                tempField['title'] = !!field.title ? field.title : '';
                tempField['notitle'] = !!field['noTitle'];
                tempField['type'] = this.convertToFormFieldType(field.type, field.displayOptions);
                tempField['placeholder'] = !!field.placeholder ? field.placeholder : field.title;
                tempField['feedback'] = false;
                tempField['disableSuccessState'] = true;
                tempField['fieldHtmlClass'] = !!field['fieldHtmlClass'] ? field['fieldHtmlClass'] : '';
                tempField['fieldHtmlClass'] += " " + this.getFieldHtmlClass(field.displayOptions);
                tempField['labelHtmlClass'] = !!field.displayOptions.labelHtmlClass? field.displayOptions.labelHtmlClass + " " : '';
                tempField['dependencies'] = field.dependencies;
                tempField['readonly'] = field['readonly'];
                tempField['readonlyOrParentEmpty'] = field['readonly'];
                tempField['condition'] = field['condition'] || field.displayOptions.condition;
                tempField['submittedForm'] = this.submittedForm || field.displayOptions.showLink;

                let vMsg = _.cloneDeep(context.validationMsg);
                tempField['validationMessage'] = !field.fieldOptions.validationMessage? vMsg : Object.assign({}, vMsg, field.fieldOptions.validationMessage);
                !!field.displayOptions.style && (tempField['style'] = field.displayOptions.style);
                !!field.displayOptions.destroyStrategy && (tempField['destroyStrategy'] = field.displayOptions.destroyStrategy);

                !!field.label && (this.parsedFieldLabels[field.label] = tempField['key']);
                if (!!field['dependencies'] && field['dependencies'].length > 0) {
                    field['dependencies'].forEach(dependency => {
                        if(!_.includes(['multipleFilterOptionsNotEqualTo', 'optionsNotIn', 'filterOptionsInArrayField'],dependency.dependType) && !!context.parsedFieldLabels[dependency['dependsOn']]){
                            dependency['dependsOn'] = context.parsedFieldLabels[dependency['dependsOn']]
                        }
                        //Dependent fields like 'goal description'/'task description' whose value is set
                        // based on another field need not be sent as answers, so saving the ids here to skip
                        // the fields when saving the form.
                        if(dependency.dependType == 'setValue'){
                            this.skipFields.push(field.key);
                        }
                    })
                }

                if(!!field.fieldOptions.preProcess){
                    this.fldOnChange(field.fieldOptions.preProcess, null);
                    !field.displayOptions.checkForUpdate && (this.autofilled.push(field.key));
                }

                //composite list with/without autofill or any other field without answer and autofill
                if ((!!this.subject || !!this.selectedSubject || this.formConfig.entityType == 'SUBJECT') && this.formConfig.status != Util.FORM_STATUS.SUBMITTED && this.canUsrEdit(field.roles) && (field.displayOptions.hasOwnProperty("autoFill") && (field.type == FIELD_TYPE.COMPOSITE_LIST || !!field.displayOptions.forceAutofill || !field.hasOwnProperty("answer")))) {
                    tempField['destroyStrategy'] = 'retain';
                    !field.displayOptions.checkForUpdate && (this.autofilled.push(field.key));
                    this.autofill(field);
                }
                if (this.formConfig.readOnly) {
                    tempField['readonly'] = this.formConfig.readOnly;
                    tempField['readonlyOrParentEmpty'] = this.formConfig.readOnly;
                } else if (!!field.displayOptions && field.displayOptions.readOnly) {
                    let rd = this.FieldService.handleParams([field.displayOptions.readOnly], this); //To handle parsedFieldLabels for forms
                    tempField['readonly'] = rd[0];
                    tempField['readonlyOrParentEmpty'] = rd[0];
                }
                if(!this.formConfig.readOnly && !!field.roles && field.roles.length){
                    if(!this.canUsrEdit(field.roles)){
                        tempField['readonly'] = true;
                        tempField['readonlyOrParentEmpty'] = true;
                    }
                }
                tempField['htmlClass'] = this.getHtmlClass(field, tempField['readonly']);
                if (!!field.displayOptions) {
                    if (field.displayOptions.inputType == FIELD_TYPE.TEXTAREA || field.displayOptions.inputType == FIELD_TYPE.RTF_TEXTAREA) {
                        tempField['rows'] = field.displayOptions.rows;
                    }
                    if (!!field.displayOptions.inputType) {
                        tempField['inputType'] = field.displayOptions.inputType;
                    }
                    if (!!field.displayOptions.appendToBody) {
                        tempField['appendToBody'] = field.displayOptions.appendToBody;
                    }
                }
                if (!!field.fieldOptions) {
                    if(!field.fieldOptions.isStdAttr) {
                        let k = _.replace(field.altKey || field.key,'fileUpload',"");
                        this.cstmAttrFlds.push(k);
                    }
                    if (field.fieldOptions.pattern) {
                        tempField['pattern'] = field.fieldOptions.pattern;
                    }
                    if (field.fieldOptions.format) {
                        tempField['format'] = field.fieldOptions.format;
                    }
                    if (!!field.fieldOptions.fieldConfigurations) {
                        tempField['canEdit'] = field.fieldOptions.fieldConfigurations.canEdit;
                    }
                    if (!!field.fieldOptions.sendHidden) {
                        tempField['sendHidden'] = field.fieldOptions.sendHidden;
                    }
                    if(!!field.fieldOptions.onChangeAction){
                        tempField['onChangeAction'] = field.fieldOptions.onChangeAction;
                    }
                    if(!!field.fieldOptions.dynamicData) {
                        tempField['dynamicData'] = field.fieldOptions.dynamicData;
                    }
                    if (!!field.fieldOptions.selectIfSingle) {
                        tempField['selectIfSingle'] = field.fieldOptions.selectIfSingle;
                    }
                    if (!!field.fieldOptions.metadata && field.fieldOptions.metadata.findIndex(m => Object.keys(m).length > 0) > -1) {
                        tempField['metadata'] = field.fieldOptions.metadata;
                    }
                    if (!!field.fieldOptions.maxLength) {
                        tempField['maxLength'] = +field.fieldOptions.maxLength;
                    }
                    if (!!field.fieldOptions.minLength) {
                        tempField['minLength'] = field.fieldOptions.minLength;
                    }
                    if (!!field.fieldOptions.maxDigits) {
                        tempField['maxDigits'] = +field.fieldOptions.maxDigits;
                    }
                    if (!!field.fieldOptions.minDigits) {
                        tempField['minDigits'] = field.fieldOptions.minDigits;
                    }
                    if (!!field.fieldOptions.maxFiles) {
                        tempField['maxFiles'] = field.fieldOptions.maxFiles;
                    }
                    !!field.fieldOptions.signPurpose && (tempField['signPurpose'] = field.fieldOptions.signPurpose);
                    if (field.type == "date") {
                        if (!!field.fieldOptions.depMinDate) {
                            tempField['depMinDate'] = _.cloneDeep(field.fieldOptions.depMinDate);
                        }
                        if (!!field.fieldOptions.depMaxDate) {
                            tempField['depMaxDate'] = _.cloneDeep(field.fieldOptions.depMaxDate);
                        }
                        if (!!field.fieldOptions.minDate) {
                            if (isNaN(parseFloat(field.fieldOptions.minDate))) {
                                if (field.fieldOptions.minDate === "CURRENT_DATE") {
                                    tempField['minDate'] = new Date().getTime();
                                } else if(field.fieldOptions.minDate === "CUSTOM_DATE"){
                                    tempField['minDate'] = jsonLogic.apply( {"adjustDate" : [new Date() ,  ...field.fieldOptions['adjustedMinDate'] ]} )
                                }
                            } else if (parseFloat(field.fieldOptions.minDate) >= 0) {
                                tempField['minDate'] = Util.getNonUTCDate(parseFloat(field.fieldOptions.minDate));
                            }
                        }
                        if (!!field.fieldOptions.maxDate){
                            if(isNaN(parseFloat(field.fieldOptions.maxDate))){
                                if(field.fieldOptions.maxDate === "CURRENT_DATE"){
                                    tempField['maxDate'] = new Date().getTime();
                                }
                            } else if(parseFloat(field.fieldOptions.maxDate) >= 0){
                                tempField['maxDate'] = Util.getNonUTCDate(parseFloat(field.fieldOptions.maxDate));
                            }
                        }
                    }

                    if(field.fieldOptions.enableSign){
                        let chk = field.fieldOptions.enableSign;
                        this.fldOnChange(chk, null);
                        tempField['enableSign'] = !field['readonly'] && this['enableSign'];
                    }
                    //parse the list for ui-select
                    if (!!field.fieldOptions.listOptions) {
                        var options = field.fieldOptions.listOptions;
                        tempField['options'] = options.map(function (item, index) {
                            return {
                                id: item.id,
                                name: item.label,
                                description: item.description,
                                parentId: item.parentId
                            };
                        });

                        if (tempField['type'] == FIELD_TYPE.UI_SELECT && !!tempField['canEdit']) {
                            // Already Exists check for editable fields
                            tempField['onDataChange'] = function (event) {
                                let filteredOpts = this.options.filter(this.filterFunc);
                                let mdl = context.parsedModel[this.key[0]];
                                let dn = context.$_utilitySer.removeExtraSpace(this.dataName);
                                if (dn == "") {
                                    context.$scope.$broadcast('schemaForm.error.' + field.key, 'emptyValue', false);
                                    context.$scope[context.formName][this.key[0]].$setValidity('emptyValue', false);
                                } else {
                                    if ($('#parent-' + this.key[0]).hasClass('has-error')) {
                                        context.$scope.$broadcast('schemaForm.error.' + field.key, 'emptyValue', true);
                                        context.$scope[context.formName][this.key[0]].$setValidity('emptyValue', true);
                                    }
                                    if (!!filteredOpts.find(item => item.id != mdl && context.$_utilitySer.removeExtraSpace(item.name) == dn)) {
                                        context.$scope.$broadcast('schemaForm.error.' + field.key, 'alreadyExists', false);
                                        context.$scope[context.formName][this.key[0]].$setValidity('alreadyExists', false);
                                    } else if ($('#parent-' + this.key[0]).hasClass('has-error')) {
                                        context.$scope.$broadcast('schemaForm.error.' + field.key, 'alreadyExists', true);
                                        context.$scope[context.formName][this.key[0]].$setValidity('alreadyExists', true);
                                    }
                                }

                            }
                            //If the field is a select type and has an answer and is editable then save the name
                            // of the option selected into dataName
                            if (!!field.answer) {
                                tempField['dataName'] = tempField['options'].find(item => item.id == field.answer).name;
                            }
                        }
                    }
                    if(!!field.fieldOptions.setNullIfHidden){
                        tempField['setNullIfHidden'] = field.fieldOptions['setNullIfHidden']
                    }

                    //Custom text to display when there are no options
                    if(tempField['type'] == FIELD_TYPE.UI_SELECT){
                        tempField['noDataText'] = field.fieldOptions.noDataText? field.fieldOptions.noDataText : "No data";
                    }
                }
                if (_.includes(this.requiredFlds, field.key) || field.required) {
                    tempField['labelHtmlClass'] += 'required-label';
                    tempField['isRequired'] = true;
                    field.required && (field.type != FIELD_TYPE.PHONE_NUMBER) && (this.checkReqFldValidation.push(field.key));
                }
                if ((field.fieldOptions.pattern && field.fieldOptions.format) || tempField['onChangeAction'] || tempField['isRequired']) {
                    var formatPhn = (modelValue, form, index) => {
                        if (!!form.pattern && !!form.format) {
                            var cleaned = ('' + modelValue).replace(/\D/g, '');
                            var rx = new RegExp(form.pattern);
                            var match = cleaned.match(rx);
                            if (match) {
                                let res = jsonLogic.apply(JSON.parse(form.format), match);
                                if(form.key.length == 1){   //For forms
                                    context.parsedModel[form.key[0]] = res;
                                } else {
                                    let fKey = form.key.join(".");
                                    if(form.keyStr && (!!index || index == 0)){
                                        fKey = _.replace(form.keyStr, new RegExp('\\[]', 'g'), '.' + index);
                                    }
                                    _.set(context.parsedModel, fKey, res);
                                }
                            }
                        }
                    };

                    tempField['onChange'] = (modelValue, form, index = null) => {
                        if(form['isRequired'] && context.formName !== "cstmAttrForm") {
                            let fldId = form.key[0];
                            let dv = $('.parent-div-' + fldId);
                            if (modelValue != undefined && modelValue !== '' && (!Array.isArray(modelValue) || modelValue.length != 0)) {
                                dv.removeClass('req-fld-div');
                                if(!(dv.scope() as any).hasError()) {
                                    dv.removeClass('has-error');
                                }
                            } else if (context.frmSaved && !$(dv).hasClass('no-edit-role')) {
                                dv.addClass('req-fld-div has-error');
                            }
                        }
                        if (form.type === FIELD_TYPE.TIME_PICKER) {
                            setTimeout(() => {
                                !!form.onChangeAction && (context.fldOnChange(form.onChangeAction, modelValue));
                            }, 0);
                        }
                        // Added a timeout function for handling checkbox fields to ensure the onChange function is executed correctly.
                        else if(form.type === FIELD_TYPE.CHECKBOXES) {
                            if(!_.includes(form.keyStr, '[]') || index != null){ //If field is a composite list element then call fldOnChange only if index is available.
                                // Use a setTimeout with a delay of 0 to ensure that the onChange function is triggered
                                // asynchronously after the current execution context completes.
                                setTimeout(() => {
                                !!form.onChangeAction && (context.fldOnChange(form.onChangeAction, modelValue , index));
                            }, 0);
                                }
                        }
                        else {
                            if(!_.includes(form.keyStr, '[]') || index != null){    //If field is a composite list element then call fldOnChange only if index is available.
                                formatPhn(modelValue, form, index);
                                !!form.onChangeAction && (context.fldOnChange(form.onChangeAction, modelValue , index));
                            }
                        }
                    }
                }

                if(field.onChangeCustom){
                    tempField['onChangeCustom'] = (modelVal, tableIndex) => {
                       this.fldOnChange(field.onChangeCustom, modelVal, tableIndex);
                    }
                }

                if (!!field.description && (_.includes(['rating', FIELD_TYPE.TABLE, 'ecv-textarea', 'rtftextarea', FIELD_TYPE.FILE_UPLOAD,'ecv-checkboxes', FIELD_TYPE.SIGNATURE, FIELD_TYPE.COMPOSITE_LIST], tempField['type']))) {
                    tempField['fieldDescription'] = field.description;
                    tempField['description'] = '';
                } else {
                    tempField['description'] = field.description;
                }

                if(field.type == FIELD_TYPE.UPLOAD_PIC){
                    tempField['addPhoto'] = function (ind, $file, $errFiles,$invalidFiles?) {
                        if (!$file){
                            if($invalidFiles[0].$error == 'maxHeight'){
                                $file=$invalidFiles[0];
                            }else{
                                return;
                            }
                        }
                        var photoPath = $file;
                        context.PopUpService.openPhotoPopUp($file).then((s) => {
                            let key = tempField['key'];
                            if(ind != undefined){ // For composite list
                                context.parsedModel[key[0]][ind][key[2]] = s.photo;
                            } else {
                                context.parsedModel[key[0]] = s.photo;
                            }
                        }, (e) => context.PopUpService.openInformationModal(e));
                    };
                }

                if(field.type == FIELD_TYPE.PHONE_NUMBER){
                    tempField['htmlClass'] += ' ecv-phone';
                    if(!!field.fieldOptions.fieldConfigurations){
                        var fieldConfigurations = field.fieldOptions.fieldConfigurations;
                        let phnCnfg = fieldConfigurations[FIELD_TYPE.PHONE];
                        phnCnfg['key'] = field['key'] +"-phone";
                        phnCnfg['label'] = field['label'] +"-phone";
                        phnCnfg['title'] = phnCnfg['fieldName'];
                        phnCnfg['type'] = FIELD_TYPE.PHONE;
                        let phn = this.parseField(phnCnfg, '');
                        //altKey and keyStr needed in case this field is part of composite list field
                        field['altKey'] && (phn['altKey'] = field['altKey'] +"-phone");
                        phn['keyStr'] = phnCnfg['key'];
                        phn['pattern'] = phnCnfg.fieldOptions.pattern;
                        phn['format'] = phnCnfg.fieldOptions.format;
                        phn['htmlClass'] += ' phn-div phone';
                        tempField['items'] = [phn];
                        let extn = fieldConfigurations[FIELD_TYPE.EXT];
                        if(!!extn){
                            extn['key'] = field['key'] +"-extension";
                            extn['label'] = field['label'] +"-extension";
                            extn['title'] = extn['fieldName'];
                            extn['type'] = FIELD_TYPE.EXT;
                            extn = this.parseField(extn, '');
                            //altKey and keyStr needed in case this field is part of composite list field
                            field['altKey'] && (extn['altKey'] = field['altKey'] +"-extension");
                            extn['keyStr'] = extn['key'];
                            extn['htmlClass'] += ' extn-div extension';
                            tempField['items'].push(extn);
                        }
                    }
                }

                //parse the values for radiobuttons
                if ((field.type == "scale") || (!!field.fieldOptions && !!field.fieldOptions.scaleLabels)) {
                    var scaleLabels = field.fieldOptions.scaleLabels;
                    if (typeof (scaleLabels) == "string") {
                        scaleLabels = JSON.parse(scaleLabels);
                    }
                    var titleMap = [];
                    for (var s in scaleLabels) {
                        titleMap.push({
                            value: parseInt(s),
                            name: scaleLabels[s]
                        });
                    }
                    tempField['titleMap'] = titleMap;
                }

                //parse the values for checkboxes
                if ((field.type == "array") || (!!field.fieldOptions && !!field.fieldOptions.valueLabels)) {
                    var valueLabels = field.fieldOptions.valueLabels;
                    if (typeof (valueLabels) == "string") {
                        valueLabels = JSON.parse(valueLabels);
                    }
                    var titleMap = [];
                    for (var s in valueLabels) {
                        titleMap.push({
                            value: parseInt(s),
                            name: valueLabels[s]
                        });
                    }
                    tempField['titleMap'] = titleMap;
                }
                //parse the text for label control
                if (field.type == "label") {
                    tempField['labelText'] = (!!field.displayOptions ? field.displayOptions.text : '');
                }
                //parse the styles for separator
                if (field.type == "separator") {
                    tempField['style'] = { 'border-style': (!!field.displayOptions ? field.displayOptions.style : 'solid') };
                    if (field.displayOptions.style == 'double') {
                        tempField['style']['border-width'] = '3px';
                    }
                }
                if (field.type == FIELD_TYPE.TIME_PICKER) {
                    tempField['meridiem'] = (field.fieldOptions.format == "12-hour");
                    this.timePckrFlds.push(tempField);
                }
                if(field.type == FIELD_TYPE.SIGNATURE){
                    (context.usrSgn && context.usrSgn.imageUrl) && (tempField['usrSign'] = context.usrSgn.imageUrl);
                    tempField['readonly'] && (tempField['usrSign'] = true);
                    tempField['isSignLckd'] = false;
                    tempField['toggleConsent'] = () => {
                        var key = tempField['key'];
                        (!context.parsedModel[key] || context.parsedModel[key] == "$$FORCE_DELETE$$") && (context.parsedModel[key] = {});
                        context.parsedModel[key]['consent'] = !context.parsedModel[key]['consent'];
                        !context.parsedModel[key]['consent'] && (tempField['resetSign']());
                    };
                    tempField['setupSign'] = () => {
                        this.$_modLoadService.getSignatureService().then((srvc) => {
                            srvc.openCreateSignaturePopup().then(success => {
                                context.usrSgn = success;
                                tempField['usrSign'] = success.imageUrl;
                                context.setUsrSignature();
                            });
                        });
                    };
                    tempField['addSign'] = () => {
                        var key = tempField['key'];
                        var sgnUrl = tempField['usrSign'];
                        var bucket = (context.FormService.ecareEnv == "my" ?'signature-ecarevault-com' : 'dev-signature-ecarevault-com');
                        this.$_com.getSignUrlFrSignature(bucket, sgnUrl).then(signedUrl => {
                            tempField['signature'] = signedUrl;
                            context.parsedModel[key]['signPurpose'] = tempField['signPurpose'];
                            context.parsedModel[key]['signature'] = sgnUrl;
                            context.parsedModel[key]['signDate'] = moment().format('MM/DD/YYYY h:mm A UTCZ');
                            $('.parent-div-' + key).removeClass('req-fld-div');
                        });
                    };
                    tempField['resetSignAftrChk'] = () => {
                        if(!tempField['enableSign']){
                            tempField['resetSign']();
                            context.parsedModel[tempField['key']] = "$$FORCE_DELETE$$";
                        }
                    };
                    tempField['resetSign'] = () => {
                        var key = tempField['key'], dv = $('.parent-div-' + key);
                        context.parsedModel[key] = undefined;
                        tempField['signature'] = undefined;
                        tempField['isSignLckd'] = false;
                        (tempField['isRequired'] && !dv.hasClass('no-edit-role') && this.frmSaved && !dv.hasClass('req-fld-div')) && (dv.addClass('req-fld-div'));
                    };

                    tempField['printForm'] = (): void => {
                        window.print();
                    };
                }

                //parse the values for counters
                if (field.type == "counter") {
                    var titleMap = [];
                    var context = this;
                    context.resetCntrForTrial = null;
                    for (let c of field.counterTypes) {
                        var tempf = angular.copy(c);
                        tempf = this.parseField(tempf, '');
                        tempf['title'] = '';
                        tempf['legend'] = c['legend'];
                        tempf['name'] = c['counterName'];
                        tempf['color'] = c['counterColor'];

                        tempf['increment'] = function (event, item, key) {
                            item['resetEnabled'] = true;
                            if (field['maxValue'] == undefined || item[key]['val'] < field['maxValue']) {
                                item[key]['val'] = parseInt(item[key]['val']) + 1;
                            }
                        }
                        titleMap.push(tempf);
                    }
                    tempField['titleMap'] = titleMap;

                    tempField['reset'] = field['reset'];
                    tempField['blurResetFn'] = function (event) {
                        let resetCntnr = $(event.target).parents('.reset-btn').siblings('.reset-text-container');
                        resetCntnr.css("display", "none");
                        clearTimeout(context.resetTimeout);
                        context.resetTimeout = null;
                        context.resetCntrForTrial = null;
                    }
                    tempField['resetFn'] = function (event, item) {
                        let resetCntnr = $(event.target).parents('.reset-btn').siblings('.reset-text-container');
                        let trial = ($(event.target).parents('.table-row')[0] as HTMLTableRowElement).rowIndex;
                        clearTimeout(context.resetTimeout);
                        context.resetTimeout = null;

                        if (!!context.resetCntrForTrial && context.resetCntrForTrial == trial) {
                            item['resetEnabled'] = false;
                            resetCntnr.css("display", "none");
                            context.resetCntrForTrial = null;
                            for (let counter in item) {
                                !!item[counter] && !!item[counter]['val'] && (item[counter]['val'] = 0);
                            }
                        } else {
                            context.resetCntrForTrial = trial;   //set the trial for which the reset button has been clicked
                            angular.element('.reset-text-container').css("display", "none");   //Hide the other popovers if any
                            let msg = "Click Reset again to reset all the counters for trial " + trial + ".";
                            resetCntnr.find('.reset-text')[0].innerHTML = msg;
                            resetCntnr.css("display", "block");
                            //Hide the popover after 10 secs
                            context.resetTimeout = setTimeout(function () {
                                resetCntnr.css("display", "none");
                                context.resetCntrForTrial = null;
                            }, 10000);
                        }
                    }
                }
                if (field.type == FIELD_TYPE.FIELDSET || field.type == FIELD_TYPE.COMPOSITE) {
                    if (field.fields && field.fields.length > 0) {
                        tempField['items'] = [];
                        for (let f of field.fields) {
                            !f['htmlClass'] && (f['htmlClass'] = "");
                            f['altKey'] = f['key'];
                            f['htmlClass'] += " " + field.key + "-" + f.key;
                            f['htmlClass'] += " " + f.key; // For required field validations inside composite list
                            f['key'] = field.key + "." + f.key;
                            f['subField'] = true;
                            f['label'] = !!field.label? field.label + "." + f.label : null;
                            let fld = this.parseField(f);
                            fld['keyStr'] = field.key + "." + f.altKey;
                            fld.altKey = f.altKey;
                            if(field.displayOptions.autoFill) {
                                let isAutofill = field.displayOptions.autoFill.find(sf => sf.targetSubField == f['altKey']);
                                !!isAutofill && (fld['destroyStrategy'] = 'retain');
                            }
                            tempField['items'].push(fld);
                        }
                    }

                }
                var processNewObject = (fldkey) => {
                    let key = Array.isArray(fldkey) ? fldkey.join() : fldkey;
                    let field = this.fetchField(this.parsedForm, null, key);
                    field['fieldOptions'] && field['fieldOptions']['default'] && (this.setDefaultFieldValue(field, true));
                    field['displayOptions'] && !field['doNotAutoFillForNew'] && field['displayOptions']['autoFill'] && (this.autofill(field, true));
                }
                if (field.type == FIELD_TYPE.COMPOSITE_LIST) {
                    let isSortable = false;
                    var formatDate = (date, format) => {
                        if (!format) {
                            format = "MM/dd/yyyy";
                        }
                        return this.$filter('date')(date, format);
                    }
                    jsonLogic.add_operation('formatDate', formatDate);
                    this.completeGoal = (index, fldKey, mdl) => {
                        if (!!mdl) {
                            mdl.completed = true;
                            mdl.disableMenu = true;
                            mdl.status = "Completed";
                            if (!!mdl['goalObjectives']) {
                                mdl['goalObjectives'].forEach(o => {
                                    o.disableMenu = true;
                                })
                            }
                            let btn = $('#' + fldKey + '-item-' + index).find('.goalObjectives-addBtn');
                            if (!!btn) {
                                $(btn).prop("disabled", true);
                            }
                            $('#' + fldKey + '-item-' + index).addClass('gray-out');
                        }
                    }
                    this.deleteItem = (index, fldKey, mdl) => {
                        if (!!mdl) {
                            mdl.deleted = true;
                            mdl.disableMenu = true;
                            mdl.status = "Deleted";
                            if (!!mdl['goalObjectives']) {
                                mdl['goalObjectives'].forEach(o => {
                                    o.disableMenu = true;
                                })
                            }
                            let btn = $('#' + fldKey + '-item-' + index).find('.goalObjectives-addBtn');
                            if (!!btn) {
                                $(btn).prop("disabled", true);
                            }
                            $('#' + fldKey + '-item-' + index).addClass('gray-out');
                        }
                    }
                    this.editItem = (index, fldKey, mdl) => {
                        if (!!mdl) {
                            mdl.editable = true;
                        }
                    }
                    this.resolveBarrier = (index, fldKey, mdl) => {
                        if (!!mdl) {
                            mdl.resolved = true;
                            mdl.disableMenu = true;
                            mdl.status = "Resolved";
                            mdl.changed = true;

                            $('#' + fldKey + '-item-' + index).addClass('gray-out');
                        }
                    }
                    this.deleteBarrier = (index, fldKey, mdl) => {
                        if (!!mdl) {
                            mdl.deleted = true;
                            mdl.disableMenu = true;
                            mdl.status = "Deleted";
                            mdl.changed = true;

                            $('#' + fldKey + '-item-' + index).addClass('gray-out');
                        }
                    }

                    (!_.includes(field.key, "[]") && !field.answer) && (field.answer = []);
                    if (field.fields && field.fields.length > 0) {
                        if (field.fieldOptions) {
                            isSortable = field.fieldOptions.sortable;
                            tempField['hideItemIf'] = false;
                            if (!!field.fieldOptions.hideItemIf) {
                                tempField['hideItemIf'] = field.fieldOptions.hideItemIf;
                                tempField['filterArr'] = (item) => {
                                    return !eval(field.fieldOptions.hideItemIf);
                                }
                            }
                            tempField['startEmpty'] = !field.fieldOptions.startWithBlankForm;
                            tempField['showIndexWithLabel'] = field.fieldOptions.showIndexWithLabel;
                            tempField['showStatus'] = field.fieldOptions.showStatus;
                            tempField['add'] = field.fieldOptions.addLabel;
                            tempField['emptyMessage'] = !!field.fieldOptions.emptyMessage ? field.fieldOptions.emptyMessage : "";
                            tempField['hideDeleteIf'] = field.fieldOptions.hideDeleteIf? field.fieldOptions.hideDeleteIf : "item.id || form.readonly || form.remove === null";
                            tempField['hideCancelIf'] = field.fieldOptions.hideCancelIf? field.fieldOptions.hideCancelIf : "!item.id || !item.status || form.readonly || form.remove === null";
                            let cmenu = field.fieldOptions.contextMenu;
                            if (!!cmenu && !!cmenu.actions) {
                                cmenu.actions.forEach(ac => {
                                    ac.clickFunc = (event, id, fldKey, mdl) => {
                                        event.preventDefault();
                                        (typeof this[ac.onClickFunction] == "function") && (this[ac.onClickFunction](id, fldKey, mdl));
                                    }
                                });
                                cmenu.hideIf = cmenu.hideIf? cmenu.hideIf : "!item.id || form.readonly || item.status";
                                tempField['contextMenu'] = cmenu;
                            }

                            if (field.fieldOptions.addBtnStyle) {
                                tempField['style'] = {
                                    "add": field.fieldOptions.addBtnStyle
                                };
                            }
                        }
                        tempField['sortOptions'] = {
                            disabled: !isSortable
                        };
                        tempField['items'] = [];
                        tempField['cancelChanges'] = (index, id, fldKey) => {
                            let mdlBck, k;
                            if (Array.isArray(fldKey) && fldKey.length > 1) {
                                k = fldKey.slice(-1)[0];
                                let bck = this.modelBak[fldKey[0]];
                                if (!!bck) {
                                    for(let m of bck) {
                                        let o = m[k];
                                        if (!!o) {
                                            mdlBck = o.find(i => i.id == id);
                                            if (!!mdlBck) {
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (!!mdlBck) {
                                    let mdl = this.parsedModel[fldKey[0]];
                                    for (let m of mdl) {
                                        if (!!m[k] && !!m[k].find(i => i.id == id)) {
                                            m[k].splice(index, 1, _.cloneDeep(mdlBck));
                                        }
                                    }
                                }
                            } else {
                                k = "";
                                if (Array.isArray(fldKey)) {
                                    k = fldKey.slice(-1)[0];
                                } else {
                                    k = fldKey;
                                }
                                if(id != undefined){
                                    mdlBck = this.modelBak[k].find(m => m.id == id);
                                } else {
                                    mdlBck = this.modelBak[k][index];
                                }
                                if (!!mdlBck) {
                                    this.parsedModel[k].splice(index, 1, _.cloneDeep(mdlBck));
                                }
                            }
                            let itemId = (id == undefined)? index : id;
                            $('#' + k + '-item-' + itemId).removeClass('gray-out');
                            let sub = $('#' + k + '-item-' + itemId).find('.gray-out');
                            !!sub && ($(sub).removeClass('gray-out'));

                            let btn = $('#' + k + '-item-' + itemId).find('.goalObjectives-addBtn');
                            if (!!btn) {
                                $(btn).prop("disabled", false);
                            }
                        }

                        for (let f of field.fields) {
                            f['altKey'] = f['key'];
                            f['key'] = field.key + "[]." + f.key;
                            f['label'] = !!field.label? field.label + "[]." + f.label : null;
                            f['subField'] = true;
                            let fld = this.parseField(f);
                            fld['keyStr'] = field.key + "[]." + f.altKey;
                            fld.altKey = f.altKey;
                            tempField['items'].push(fld);
                        }
                    }
                }
                if (field.type == FIELD_TYPE.TABLE) {
                    var tempAry = [];
                    var headers = [];
                    var cols = field.fieldOptions.cols;
                    for (var c = 0 ; c < cols.length; c++) {
                        var temp = _.cloneDeep(cols[c]);
                        if(temp['type'] == "label") {
                            temp['type'] = "label-alt";
                        }
                        temp['key'] = field.key + "[]." + cols[c]['key'];
                        temp['subField'] = true;
                        temp = this.parseField(temp, '');
                        temp['title'] = '';
                        temp['colid'] = cols[c]['key'];
                        temp['rowid'] = cols[c]['id'];
                        temp['valueKey'] = cols[c]['valueKey'] ? cols[c]['valueKey']: cols[c]['key'];
                        tempAry.push(temp);
                        let header = {};
                        header['name'] = cols[c]['header'];
                        header['colWidth'] = cols[c]['colWidth'];
                        headers.push(header);
                        this.fieldCount += 1;
                    }
                    if(field.fieldOptions.addNew){  //For delete row action
                        let header = {};
                        header['name'] = '';
                        header['colWidth'] = '5%';
                        headers.push(header);
                    }
                    tempField['items'] = tempAry;
                    tempField['headers'] = headers;
                    tempField['hideDeleteIf'] = field.fieldOptions.hideDeleteIf? field.fieldOptions.hideDeleteIf : false;
                    if (!!field.fieldOptions.hideItemIf) {
                        tempField['hideItemIf'] = field.fieldOptions.hideItemIf;
                    }
                    if(field.fieldOptions.ignoreRow) {tempField['ignoreRow'] = field.fieldOptions.ignoreRow;}
                    if(!!field.fieldOptions.fieldConfigurations){
                        tempField['maxRows'] = field.fieldOptions.defaultRows;
                        var fieldConfigurations = field.fieldOptions.fieldConfigurations;
                        for (let config of fieldConfigurations) {
                            if (config.option == "Trial Count") {
                                config.field = field;
                            }
                        }
                        field.fieldOptions.fieldConfigurations = fieldConfigurations;
                    }else{
                        tempField['maxRows'] = field.fieldOptions.defaultRows ;
                    }

                    if (field.fieldOptions.addNew) {
                        tempField['add'] = field.fieldOptions.addNew;
                        tempField['addRow'] = () => {
                            this.parsedModel[tempField['key']].push({});
                            !!tempField['processNewObject'] && (tempField['processNewObject'](tempField['key']));
                        }
                        tempField['deleteRow'] = (index) => {
                            this.parsedModel[tempField['key']].splice(index, 1);
                        }
                    }
                }

                if (_.includes([FIELD_TYPE.COMPOSITE_LIST, FIELD_TYPE.TABLE], field.type)) {
                    //To set the objDeleted which is used by the handleDestroy directive
                    tempField['setDelFlag'] = (elmScope) => {
                        let parentElement = elmScope.$parent;
                        elmScope.$parent.$parent.$parent.objDeleted = true;
                        setTimeout(() => {
                            elmScope.$parent = parentElement;
                            elmScope.$parent.$parent.$parent.objDeleted = false;
                        },100);
                    }
                    if (field.fieldOptions && field.fieldOptions.onDeleteFromArray) {
                        tempField['onDeleteFromArray'] = (tableIndex) => {
                            this.fldOnChange(field.fieldOptions.onDeleteFromArray, null, tableIndex);
                            this.checkReqFldValidation.forEach(r => {
                                if(_.includes(r, '[]')){   //composite list
                                    let keys = r.split('[].');
                                    let prnt = keys[0];
                                    let sub = keys[1];
                                    if(!!this.parsedModel[prnt]) {
                                        this.parsedModel[prnt].forEach((s,index) => {
                                            let dv = $("."+prnt+"-"+index+"-"+sub);
                                            if(dv.length > 0 && !$(dv).hasClass('no-edit-role')){
                                                let mdl = s[sub];
                                                if(_.includes(sub, 'fileUpload') && !!mdl['documents']){
                                                    if( mdl['documents'].length == 0 ){
                                                        setTimeout(() => {
                                                            dv.addClass('req-fld-div has-error');
                                                        },100);
                                                    } else {
                                                        setTimeout(() => {
                                                            dv.removeClass('req-fld-div has-error');
                                                        },100);
                                                    }
                                                } else {
                                                    if(mdl == undefined || mdl === '' || (Array.isArray(mdl) && mdl.length == 0)){
                                                        setTimeout(() => {
                                                            dv.addClass('req-fld-div has-error');
                                                        },100);
                                                    } else {
                                                        setTimeout(() => {
                                                            dv.removeClass('req-fld-div has-error');
                                                        },100);
                                                    }
                                                }
                                            }
                                        })
                                    }
                                }
                            });
                        }
                    }
                    if (field.displayOptions.hasOwnProperty("autoFill") || field.fieldOptions.hasOwnProperty("default")) {
                        if (field.displayOptions.hasOwnProperty("autoFill")) {
                            tempField['displayOptions'] = {
                                'autoFill': field.displayOptions.autoFill
                            };
                        }
                        if (field.fieldOptions.hasOwnProperty("default")) {
                            tempField['fieldOptions'] = {
                                'default': field.fieldOptions.default
                            };
                        }
                        tempField['doNotAutoFillForNew'] = field['displayOptions']['doNotAutoFillForNew'];
                        tempField['processNewObject'] = processNewObject;
                    }
                }

                if (field.type == "fieldArray") {
                    var tempAry = [];
                    var headers = [];
                    var cols = field.fieldOptions.fieldItems;
                    for (var c = 0 ; c < cols.length; c++) {
                        var tempf = angular.copy(cols[c]);
                        if(tempf['type'] == "label") {
                            tempf['type'] = "label-alt";
                        }
                        tempf['key'] = field.key + "." + cols[c]['key'];
                        tempf = this.parseField(tempf, '');
                        tempf['title'] = '';
                        tempAry.push(tempf);
                        this.fieldCount += 1;
                    }
                    tempField['items'] = tempAry;
                }

                if(field.type == FIELD_TYPE.SUBJECTS){
                    tempField['allTeams'] = [];
                    tempField['formName'] = context.formName;
                    if(!!field.fieldOptions){
                        tempField['teamsFilter'] = field.fieldOptions.teamsFilter;
                        tempField['customFilter'] = !!field.fieldOptions.customFilter? this.FieldService.handleParams(field.fieldOptions.customFilter,this) : null;
                        tempField['addNewTeamMsg'] = field.fieldOptions.addNewTeamMsg? field.fieldOptions.addNewTeamMsg : null;
                        tempField['multiple'] = field.fieldOptions.multiple;
                        tempField['permCheck'] = field.fieldOptions.permCheck;
                        tempField['includeCustomAttributes'] = field.fieldOptions.includeCustomAttributes;
                        tempField['searchBy'] = field.fieldOptions.searchBy;
                        tempField['searchFormat'] = field.fieldOptions.searchFormat;
                        tempField['searchPattern'] = field.fieldOptions.searchPattern;
                        tempField['teamDetails'] = field.fieldOptions.teamDetails;
                    }
                    if(tempField['addNewTeamMsg']) {
                        tempField['addNewCR'] = (ind) => {
                            context.$_modLoadService.getCreateTeamService().then((CreateTeamService) => {
                                const fn = function () {
                                    return 'CR';
                                };
                                CreateTeamService.openAddNewCRPopup(fn, null).then(
                                    function (s) {
                                        let key = tempField['key'];
                                        if (!!tempField['multiple']) {
                                            if(ind != undefined){ // For composite list
                                                !context.parsedModel[key[0]][ind][key[2]] && (context.parsedModel[key[0]][ind][key[2]] = []);
                                                context.parsedModel[key[0]][ind][key[2]].push(s);
                                            } else {
                                                !context.parsedModel[key[0]] && (context.parsedModel[key[0]] = []);
                                                context.parsedModel[key[0]].push(s);
                                            }
                                            s.selected = true;
                                        } else {
                                            if(ind != undefined){ // For composite list
                                                context.parsedModel[key[0]][ind][key[2]] = s;
                                            } else {
                                                context.parsedModel[key[0]] = s;
                                            }
                                        }
                                        var successMsg = "";
                                        if (s.subjectTypeId == 'INDIVIDUAL') {
                                            successMsg = Util.ADD_CR_SUCCESS.replace('$subjectFullName', s.fullName);
                                        } else {
                                            successMsg = Util.ADD_PROJECT_SUCCESS.replace('$subjectFullName', s.fullName);
                                        }
                                        toastr.success(successMsg);
                                        //BroadcastService.broadcast('add-new-team');
                                    },
                                    function (e) {
                                    });
                            });
                        }
                    }
                }
                if(field.type == FIELD_TYPE.USERS){
                    let sortOn = {
                        "properties": [
                            "fullName",
                            "firstName"
                        ],
                        "direction": "ASC"
                    };
                    let cstmFilter = !!field.fieldOptions.userFilter? this.FieldService.handleParams(field.fieldOptions.userFilter,this) : null;
                    tempField['resetUser']=() =>{
                        this.BroadcastService.broadcast('reset-selected-member',null);
                    }
                    tempField['loadUsers']=(page, size, search)=>{
                        var deferred = this.$q.defer();
                        let filter = {
                            "fullName": search
                        }
                        Object.assign(filter, cstmFilter);
                        if (page == 0 || this.loadMore) {
                            this.$_api.fetchUsers(this.orgId,  page, size,sortOn, filter).then(data => {
                                this.loadMore = page + 1 < data.totalPages;
                                let filterData;
                                if(!!field.fieldOptions.respFilter){
                                    let values = this.fetchValueSource(field.fieldOptions.respFilter, null);
                                    filterData=data.content.filter(i => { values['result'] = i; return jsonLogic.apply(field.fieldOptions.respFilter.rule, values);});
                                } else {
                                    filterData=data.content;
                                }
                                deferred.resolve(filterData);
                            });
                        } else {
                           deferred.resolve([]);
                        }
                        return deferred.promise;
                    }

                    if(!!field.fieldOptions){
                        tempField['showEmail'] = field.fieldOptions.showEmail;
                        tempField['hideClearBtn'] = field.fieldOptions.hideClearBtn;
                        tempField['memDetails'] = field.fieldOptions.memDetails;
                        tempField['hideLabel'] = field.fieldOptions.hideLabel;
                    }
                }
                let dynamicListApiPromise;


                if(field.type == FIELD_TYPE.DYN_UI_SELECT){

                    let params = field.fieldOptions.listOptionsMetadata;
                    let apiConfig;
                    if(!!this.apiKey){
                        apiConfig = this.FieldService.handleParams(params['web']['external']);
                    } else {
                        apiConfig = this.FieldService.handleParams(params['web']['app']);
                    }
                    let apiType = !!apiConfig['type'] ? apiConfig['type'] : API_TYPE.API;
                    let cnf = field.fieldOptions.fieldMetadata;
                    cnf['name'] = tempField['key'];
                    cnf['formUtil'] = this;
                    cnf['apiConfig'] = apiConfig;
                    tempField['fldConfig'] = cnf;
                    (cnf['groupBy'] && typeof this[cnf['groupBy']] == "function") && (tempField['groupFn'] = this[cnf['groupBy']]);
                    tempField['disableSelection'] = !!apiConfig.disableSelection? apiConfig.disableSelection : false;
                    this.pendingDUS += 1;
                    this.dynamicFields[field['label'] || field['key']] = tempField['fldConfig'];
                    let parseResp = (result) => {
                        this.depModel = null;
                        tempField['fldConfig']['ddOptions'] = tempField['options'] = result;
                        if (!!tempField['dependencies'] && tempField['dependencies'].length > 0) {
                            tempField['dependencies'].forEach(dependency => {
                                if (dependency.dependType == 'filterOptions') {
                                    this.depModel = this.parsedModel[dependency['dependsOn']];
                                } else if (dependency.dependType == 'filterOptionsExternal') {
                                    this.depModel = this.FieldService.handleParams(dependency);
                                } else if (dependency.dependType == 'optionsNotIn') {
                                    this.depModel = true;
                                }
                                else if (dependency.dependType == 'multipleFilterOptionsNotEqualTo') {
                                    if (tempField['filterFunc']) {
                                        this.depModel = true;
                                    }
                                }
                            });

                            if (!!this.depModel) {
                                let filteredOpts = result.filter(tempField['filterFunc']);
                                tempField['fldConfig']['ddOptions'] = filteredOpts;
                                if (!this.formConfig.readOnly && !!tempField['selectIfSingle'] && filteredOpts.length == 1) {
                                    this.parsedModel[tempField['key']] = filteredOpts[0]['id'];
                                    tempField['fldConfig']['value'] = filteredOpts[0];
                                }
                            }
                        }

                        if (!!field.answer || !!field['valueId']) {
                            let ans;
                            if(field.answer){
                            ans = field.displayOptions.returnType == 'string' ? field.answer : JSON.parse(field.answer);
                            } else if(!!field['valueId']){
                                ans = field['valueId'];
                            }
                            if (field.displayOptions.inputType == 'single-select') {
                                tempField['fldConfig']['value'] = result.find(r => r.id == ans);
                            } else {
                                tempField['fldConfig']['value'] = _.map(ans, u => {
                                    let usr;
                                    if(typeof(u) == 'number') {
                                        usr = result.find(r => r.id == u);
                                        if (!!usr) {
                                            return usr;
                                        } else {
                                            return u;
                                        }
                                    } else {
                                        usr = result.find(r => r.id == u.id);
                                        if (!!usr) {
                                            return usr;
                                        } else {
                                            return !!apiConfig['respMdl'] ? new RespModel[apiConfig['respMdl']]().deserialize(u) : u;
                                        }
                                    }
                                });
                            }
                        }

                        tempField['fldConfig']['filterFunc'] = tempField['filterFunc'];
                    }

                    let callFn = () => {
                        let deferred = this.$q.defer();
                        context.APIService.callApi(apiConfig['azureUrl'],
                        apiConfig['method'],
                        apiConfig['body'],
                        apiConfig['queryParams'],
                        apiType
                        ).then(
                            s => {
                                var result = [];
                                if (!!s) {
                                    !!apiConfig['addNoneOption'] && !!apiConfig['respMdl'] && result.push(new RespModel[apiConfig['respMdl']](-1, NULL_TEXT));
                                    for (var i = 0; i < s.length; i++) {
                                        var temp = !!apiConfig['respMdl'] ? new RespModel[apiConfig['respMdl']]().deserialize(s[i]) : s[i];
                                        if (!!temp)
                                            result.push(temp);
                                    }
                                }
                                if(!!apiConfig['parseResp'] && typeof this[apiConfig['parseResp']] == "function") {
                                    result = this[apiConfig['parseResp']](result);
                                }
                                !!apiConfig.cacheResp && this.$_cache.set(apiConfig.cacheResp, result,true);
                                parseResp(result);
                                deferred.resolve(result);
                            }
                        ).catch(err => {
                            console.error('API Error:', err);
                            deferred.reject(err);
                        }).finally(() => {
                            this.pendingDUS -= 1;
                        });
                        return deferred.promise;
                    }

                    if (!!apiConfig.cacheResp) {
                        let rs = this.$_cache.get(apiConfig.cacheResp, true);
                        if (!!rs) {
                            parseResp(rs);
                            this.pendingDUS -= 1;
                            dynamicListApiPromise = this.$q.resolve(rs);
                        } else {
                            dynamicListApiPromise = callFn();
                        }
                    } else {
                        dynamicListApiPromise = callFn();
                    }
                }

                tempField = this.addCustomValidators(field, tempField);
                tempField = this.addCustomTypeProperties(tempField);
                var parsedFieldSchema = this.parseFieldSchema(field);
                this.addSchema(parsedFieldSchema, field.key);
                if(this.setModel){
                    field.answer = this.setModel[field.key];
                }
                this.parseModel(field, parsedFieldSchema, tempField).then(s => {
                    if(field.type == FIELD_TYPE.SIGNATURE && !!context.parsedModel[tempField['key']] && !!context.parsedModel[tempField['key']]['signature']){
                        var bucket = (context.FormService.ecareEnv == "my" ?'signature-ecarevault-com' : 'dev-signature-ecarevault-com');
                        this.$_com.getSignUrlFrSignature(bucket, context.parsedModel[tempField['key']]['signature']).then(signedUrl => {
                            tempField['signature'] = signedUrl;
                            tempField['isSignLckd'] = true;
                        });
                    }

                    if (field.type == FIELD_TYPE.COMPOSITE_LIST && !!field.fieldOptions) {
                        if (!!field.fieldOptions.sort) {
                            let sortObj = field.fieldOptions.sort;
                            let sortOn = _.map(sortObj.sortOn, itr => {
                                return _.iteratee(itr);
                            });
                            this.parsedModel[field.key] = _.orderBy(this.parsedModel[field.key], sortOn, sortObj.direction);
                        }
                        if (!!field.fieldOptions.headerText) {
                            let flt = field.fieldOptions.headerText;
                            let len = this.parsedModel[field.key].length;
                            this.parsedModel[field.key].forEach((i, ind) => {
                                i.headerText = jsonLogic.apply(flt, i);
                                i.isPanelOpen = (ind == len - 1) ? true : false;
                            });
                        }
                    }

                    if(field.type == FIELD_TYPE.HYPERLINK){
                        tempField['openPopup'] = this.openPopup;
                        tempField['navigateTo'] = this.navigateTo;
                    }
                    if (!!field['dependencies']) {
                        let dep = field['dependencies'].find(d => d.dependType == 'setValue');
                        if(!!dep){
                            let depModel = this.parsedModel[dep['dependsOn']];
                            if(!!depModel && !!field.fieldOptions && !!field.fieldOptions.listOptions) {
                                let list = field.fieldOptions.listOptions;
                                let opt = list.find(o => o.id == depModel);
                                this.parsedModel[tempField['key']] = opt[dep['dependValue']];
                                if(!this.parsedModel[tempField['key']] || this.parsedModel[tempField['key']].length == 0){
                                    if (!!field.fieldOptions && !!field.fieldOptions.fieldConfigurations) {
                                        let fieldConfigurations = field.fieldOptions.fieldConfigurations;
                                        if(!tempField['canEdit'] || this.isReadOnly){
                                            tempField['placeholder'] = tempField['title'];
                                        } else if (!!fieldConfigurations.defaultText) {
                                            tempField['placeholder'] = fieldConfigurations.defaultText;
                                        }
                                    }
                                }
                            }
                        }
                        dep = field['dependencies'].find(d => d.dependType == 'filterOptions' || d.dependType == 'multipleFilterOptionsNotEqualTo');
                        if (!!tempField['selectIfSingle'] && !!dep) {
                            let depModel = this.parsedModel[dep['dependsOn']];
                            if (!!depModel && !!field.fieldOptions && !!field.fieldOptions.listOptions) {
                                let list = field.fieldOptions.listOptions;
                                let filteredOpts = list.filter(tempField['filterFunc']);
                                if (filteredOpts.length == 1) {
                                    this.parsedModel[tempField['key']] = filteredOpts[0]['id'];
                                }
                            }
                        }
                    }

                    if(!!field.fieldOptions.postProcess){
                        if(field.type == FIELD_TYPE.DYN_UI_SELECT){
                            dynamicListApiPromise.then(() => {
                                this.fldOnChange(field.fieldOptions.postProcess, null);
                            });
                        } else {
                            this.fldOnChange(field.fieldOptions.postProcess, null);
                        }
                    }
                }).finally(() => {
                    (field.displayOptions.inputType != 'label') && (this.pendingParsedFields -= 1);
                });


                return tempField;

            }
            this.changeRqdCls = (fieldLbl) => {
                var deferred = this.$q.defer();
                let key = !!this.parsedFieldLabels[fieldLbl]? this.parsedFieldLabels[fieldLbl] : fieldLbl;
                let depFld = this.fetchField(this.parsedForm, null, key);
                let modelValue = depFld.fldConfig.value;
                let val;
                if (depFld.inputType == FIELD_TYPE.SINGLE_SELECT) {
                    val = modelValue.id;
                } else {
                    val = angular.copy(modelValue);
                }
                _.set(this.parsedModel, key, val);
                let dv = $('.parent-div-' + key);
                if(!!modelValue && (depFld.inputType == FIELD_TYPE.SINGLE_SELECT || modelValue.length > 0)) {
                    dv.removeClass('req-fld-div');
                    if($('#parent-'+ key).hasClass('has-error')) {
                        this.$scope.$broadcast('schemaForm.error.' + key, 'tv4-302', true);
                    }
                } else if(this.frmSaved && !$(dv).hasClass('no-edit-role')) {
                    dv.addClass('req-fld-div');
                }
                depFld.resetDependent();
                deferred.resolve();
                return deferred.promise;
            }

            this.setDynDrpdwnVal = (fieldLbl) => {
                var deferred = this.$q.defer();
                let key = !!this.parsedFieldLabels[fieldLbl]? this.parsedFieldLabels[fieldLbl] : fieldLbl;
                let depFld = this.fetchField(this.parsedForm, null, key);
                let modelValue = depFld.fldConfig.value;
                let val;
                if (depFld.inputType == FIELD_TYPE.SINGLE_SELECT) {
                    val = modelValue.id;
                } else {
                    val = angular.copy(modelValue);
                }
                _.set(this.parsedModel, key, val);
                depFld.resetDependent();
                deferred.resolve();
                return deferred.promise;
            }

            this.generateResponse = (skipBkup=false) => {
                var deferred = this.$q.defer();
                var res = {};
                var context = this, deleteRespArr = ["$$DELETE$$", "$$FORCE_DELETE$$"];
                var schema = this.parsedSchema, modelCpy = _.cloneDeep(this.parsedModel), modelBakCpy = angular.copy(this.modelBak);
                let  formDocs;
                var processModel = (fldSchema, fld, model, p,index?) => {

                    if (fldSchema['valueType'] == FIELD_TYPE.DYN_UI_SELECT && !!fld && fld['inputType'] == FIELD_TYPE.MULTI_SELECT && !!fld['fldConfig']['value']) {
                        if (fld['fldConfig']['value'].length > 0) {
                            model = _.map(fld['fldConfig']['value'], 'id');
                        } else {
                            model = null;
                        }
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.DYN_UI_SELECT && !!fld && fld['inputType'] == FIELD_TYPE.SINGLE_SELECT && !model) {
                        model = null;
                    }
                    if(_.includes([FIELD_TYPE.DYN_UI_SELECT, FIELD_TYPE.UI_SELECT], fldSchema['valueType']) && (model == -1 || model == NULL_TEXT)) {
                        model = null;
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.SUBJECTS && !!model) {
                        if(!!fld && fld['inputType'] == 'single-select'){
                            model = model.subjectId;
                        } else {
                            model = _.map(model, 'subjectId');
                        }
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.USERS && !!model) {
                        if(!!fld && fld['inputType'] == 'single-select'){
                            model = model.id;
                        } else {
                            model = _.map(model, 'id');
                        }
                    }
                    let autofill: boolean = !!this.autofilled.find(n => n == fldSchema.id);
                    let oldProp = autofill ? null : (skipBkup? null : _.cloneDeep(this.modelBak[p]));
                    if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST) {
                        if (!!model) {
                            _.remove(model, m => Object.keys(m).length == 0);
                            model = model.map((item, index) => {
                                item['index'] = index + 1;
                                if('isPanelOpen' in item){
                                    delete item['isPanelOpen'];
                                }
                                if('headerText' in item){
                                    delete item['headerText'];
                                }
                                return item;
                            });
                        }
                        if (!!oldProp) {
                            oldProp = oldProp.map((item, index) => {
                                item['index'] = index + 1;
                                if('isPanelOpen' in item){
                                    delete item['isPanelOpen'];
                                }
                                if('headerText' in item){
                                    delete item['headerText'];
                                }
                                return item;
                            });
                        }
                    }

                    if(fldSchema['valueType'] == FIELD_TYPE.TEXTAREA && !oldProp && model == "") {
                        model = undefined;
                    }
                    if(fldSchema['valueType'] == FIELD_TYPE.TEXT && !oldProp && model == "") {
                        model = null;
                    }

                    if (!!fldSchema['subField'] ||
                        !fldSchema['id'] || (!fld['forceSend'] && _.isEqual(oldProp, model)) ||
                        ((fldSchema['type'] == 'date' || fldSchema['type'] == 'time') && oldProp + "" == model + "")) {
                        return;
                    }

                    var ans = model;

                    if (fldSchema['valueType'] == 'date' && ans != null && !_.includes(deleteRespArr, ans)) {
                        ans = Util.getUTCTime(new Date(ans));
                    } else if (fldSchema['valueType'] == FIELD_TYPE.TIME_PICKER && ans != null && !_.includes(deleteRespArr, ans)) {
                        ans = Util.getUTCDateTime(ans);
                    } else if (fldSchema['type'] == 'boolean' && fldSchema['valueType'] == 'number'){
                        ans = !!model? 1 : 0;
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST || fldSchema['valueType'] == FIELD_TYPE.TABLE) {
                        let items = fldSchema['items']['properties'];
                        if (!!model) {
                            model.forEach((ans,index) => {
                                Object.keys(items).forEach(k => {
                                    let key = k;
                                    if (ans[k] != null && ans[k] != undefined) {
                                        let itmFld = context.fetchField(this.parsedForm, items[k]['id']);
                                        if(fldSchema['valueType'] == FIELD_TYPE.TABLE){
                                            let temp = ans[k];
                                            delete ans[k];
                                            let valueKey = fld.items.find(i => i.colid == k).valueKey;
                                            _.set(ans, valueKey, processModel(items[k], itmFld, temp, k,index));
                                        } else {
                                            let fldVisible = true;
                                            let fldAns;
                                            if(!!itmFld && !!itmFld.condition && itmFld.setNullIfHidden){
                                                let cnd = _.replace(itmFld.condition,new RegExp('arrayIndex', 'g'), index);
                                                try {
                                                    fldVisible = Function("const model = this.modelCpy; const modelBak = this.modelBakCpy; return " + cnd).apply(obj);
                                                } catch (error) {
                                                    console.log('Error : ', error);
                                                }
                                            }
                                            if(!fldVisible){
                                                delete ans[k];
                                            } else {
                                                if (items[k]['valueType'] == FIELD_TYPE.FILE_UPLOAD) {
                                                    key = k.split(FIELD_TYPE.FILE_UPLOAD).slice(-1)[0];
                                                }
                                                ans[key] = processModel(items[k], itmFld, ans[k], k, index);
                                                if (items[k]['valueType'] == FIELD_TYPE.FILE_UPLOAD) {
                                                    !!ans[FIELD_TYPE.FILE_UPLOAD + key] && delete ans[FIELD_TYPE.FILE_UPLOAD + key]
                                                }
                                            }
                                        }
                                    } else if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST && items[k]['type'] == 'boolean' && items[k]['valueType'] == 'number'){
                                        ans[k] = 0;
                                    }
                                });
                            })
                        }
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.FILE_UPLOAD && !_.includes(deleteRespArr, modelCpy)) {
                        let fldSchemaId= _.replace(fldSchema['id'],FIELD_TYPE.FILE_UPLOAD,"")
                        let keyArr = fldSchemaId.split('.');
                        let fieldId = keyArr.slice(-1)[0];
                        let prnt = _.replace(keyArr[0],`[]`,`[${index}]`)
                        if (!!model['documents']) {
                            let documents = model['documents'].filter(f => !!f['photoFile']);
                            !formDocs && (formDocs = {});
                            !_.has(formDocs,prnt) && _.set(formDocs, prnt, {});
                            if (keyArr.length > 1) {
                                _.set(formDocs, `${prnt}.${fieldId}`, documents);
                            } else {
                                _.set(formDocs, fieldId, documents);
                            }
                        }
                        if (!!model['filenames']) {
                            model['filenames'] = model['filenames'].map((t) => {
                                if(!t.documentId){
                                    return t.fullFilename;
                                } else {
                                    return { "documentId": t.documentId, "fileName": t.fullFilename };
                                }
                            });
                            ans = model['filenames'];
                        }
                    }
                    if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE) {
                        let items = fldSchema['items']['properties'];
                        if (!!model && Object.keys(model).length > 0) {
                            Object.keys(items).forEach(k => {
                                let key = k;
                                if (model[k] != null && model[k] != undefined) {
                                    let itmFld = context.fetchField(this.parsedForm, items[k]['id']);
                                    if (itmFld['type'] == FIELD_TYPE.FILE_UPLOAD) {
                                        key = k.split(FIELD_TYPE.FILE_UPLOAD).slice(-1)[0]
                                     }
                                    model[key] = processModel(items[k], itmFld, model[k], k);
                                    if (items[k]['valueType'] == FIELD_TYPE.FILE_UPLOAD) {
                                        !!model[FIELD_TYPE.FILE_UPLOAD+key] && delete model[FIELD_TYPE.FILE_UPLOAD+key]
                                    }
                                }
                            });
                        } else {
                            ans = undefined;
                        }
                    }
                    return ans;
                }
                const obj = {modelCpy, modelBakCpy};
                for (var p in schema.properties) {
                    let fldSchema = schema.properties[p];
                    let fld = context.fetchField(this.parsedForm, fldSchema['id']);
                    let fldVisible = true;
                    if(!!fld && !!fld.condition && !_.includes(fld.condition, 'arrayIndex') && !fld.sendHidden){
                        try {
                            fldVisible = Function("const model = this.modelCpy; const modelBak = this.modelBakCpy; return " + fld.condition).apply(obj);
                        } catch (error) {
                            console.log('Error : ', error);
                        }
                    }
                    if (!fldVisible && fld['setNullIfHidden']) {
                        if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE) {
                            let items = fldSchema['items']['properties'];
                            res[fldSchema['id']] = {};
                            Object.keys(items).forEach(k => {
                                res[fldSchema['id']][k] = null;
                            });
                        } else
                            res[fldSchema['id']] = null;
                    }
                    if (modelCpy && fldVisible) {
                        let val = processModel(fldSchema, fld, modelCpy[p], p);
                        if(fldSchema['valueType'] == FIELD_TYPE.FILE_UPLOAD){
                            let k = _.replace(p,FIELD_TYPE.FILE_UPLOAD,"");
                            res[k] = val;
                        }else{
                             res[fldSchema['id']] = val;
                        }
                    }
                }
                res["formDocs"]= formDocs;
                return res;
            }

            this.fetchField = (form: any, fieldId: any, fieldKey?: any) => {
                for (let sec of form) {
                    let fld = this.parseItems(sec, fieldId, fieldKey);
                    if (!!fld) {
                        return fld;
                    }
                }
                return null;
            }

            //Fetches a particular field from the parsedForm
            this.parseItems = (formSection: any, fieldId: any, fieldKey?: any) => {
                let field;
                let fId = !!fieldId ? fieldId : fieldKey;
                if (formSection.hasOwnProperty("schema") && ((!!fieldId && formSection.schema.id == fieldId) || (!!fieldKey && !!formSection.key.includes(fieldKey)))) {
                    field = formSection;
                    return field;
                } else {
                    let items = [];
                    if (formSection.hasOwnProperty("tabs")) {
                        items = formSection.tabs;
                    } else if(formSection.hasOwnProperty("items") && !!formSection.key && !!formSection.key.includes(fId)) {
                        return formSection;
                    } else if (formSection.hasOwnProperty("items")) {
                        items = formSection.items;
                    }  else if (!!formSection.key && !!formSection.key.includes(fId)) {
                        return formSection;
                    } else if (!!formSection.keyStr && formSection.keyStr == fId) {
                        return formSection;
                    } else {
                        return field;
                    }
                    for (let item of items) {
                        field = this.parseItems(item, fieldId, fieldKey);
                        if (field != undefined) {
                            return field;
                        }
                    }
                }
            }

            this.parseSection = (section) => {
                var sectionClass = 'section-title';
                var listType = '';
                var htmlClass = '';
                if(section.width){
                    htmlClass = section.htmlClass? section.htmlClass : '';
                    htmlClass += " col-xs-12";
                    var fieldWidth = this.getFieldWidth(section.width, 12);
                    htmlClass += " col-md-" + fieldWidth;
                } else {
                    htmlClass = section.htmlClass? section.htmlClass : 'row';
                }
                var maxRows = 50;
                section['items'] = [];
                section['htmlClass'] = htmlClass;
                section['type'] = !!section.type ? section.type : "section";

                (section.type == 'accordion-group') && (section['tabs'] = []);
                if (!!section['title'] && section.type != 'accordion-group') {
                    section['items'].unshift(
                        {
                            type: "help",
                            helpvalue: "<div class=" + sectionClass + ">" + section.title + "</div>"
                        }
                    );
                }
                if(!!section.sections) {
                    for (var j = 0; j < section.sections.length; j++) {
                        if (section.type == 'accordion-group') {
                            section['isPanelOpen'] = !this.formConfig.readOnly;
                            section['tabs'].push(this.parseSection(section.sections[j]));
                        } else {
                            section['items'].push(this.parseSection(section.sections[j]));
                        }

                    }
                    delete section.sections;
                }
                if (!!section.fields) {
                    for (var i = 0 ; i < section.fields.length; i++) {
                        var tempField = this.parseField(section.fields[i], listType);
                        section['items'].push(tempField);
                    }
                    delete section.fields;
                }

                if (section.actions) {
                    section.actions.forEach((data,index)=>{
                        if(!!data.checkPermission){
                            section.actions[index].isPermited = this.checkPermission(this.subject,data.checkPermission)
                        }
                        else{
                            section.actions[index].isPermited = true
                        }
                    })
                    section.openPopup = this.openPopup;
                }

                //dependencies to handle hide and show sections
                if(!!section.dependencies){
                    let depArr = [];
                    section.dependencies.forEach(d=>{
                        let str = this.getCndStr(d);
                        if (!!str) {
                            depArr.push(str);
                        }
                    });
                    if(!!section.condition && section.dependencies.length > 0){
                        section['condition'] = section['condition'] + ' && ' + depArr.join(' && ');
                    }
                    else if(section.dependencies.length > 0){
                        section['condition'] = depArr.join(' && ');
                    }
                }
                return section;
            }

            this.navigateTo = (event, params, entity) => {
                this.FormService.navigateTo(event,params,entity, this.subjectId,this.subject);
            }

            this.openPopup = (event, params) => {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                const apiParams = this.FieldService.handleParams(params,this);
                if (apiParams.type == POPUP_TYPE.CUSTOM_ATTRS) {
                    this.$uibModal.open({
                        templateUrl: 'app/common/customAttributeTemplate/components/showCustomAttributePopup/showCustomAttr.html',
                        controller: 'ShowCustomAttrController as cstmAttrVm',
                        backdrop: 'static',
                        keyboard: false,
                        windowClass: 'cstm-attr-container',
                        resolve: {
                            team: () => this.subject || null,
                            apiParams: () => apiParams
                        }
                    }).result.then((s) => {
                        console.log(s);
                    }, (e) => {
                        console.log(e);
                    });
                } else if (apiParams.type == POPUP_TYPE.REPORTS){
                    this.$uibModal.open({
                        templateUrl: 'app/common/analyticsReport/components/showReport/showReport.html',
                        backdrop: 'static',
                        keyboard: false,
                        controller: 'showReportController as showReportVm',
                        windowClass: 'report-modal',
                        resolve: {
                            params: () => apiParams.reportParams,
                            subjectId: () => this.subject.subjectId,
                            ecvId:()=>this.subject.uniqueId
                        }
                    }).result.then(
                        success => { console.log(success) },
                        error => { console.log(error); }
                    );
                }
            };

            this.penddingDynUiSelect = () => {
                return this.pendingDUS;
            }

            //This will be called when user sets up a new signature
            this.setUsrSignature = () => {
                this.signFlds.forEach(sf => {
                    let fld = this.fetchField(this.parsedForm, null, sf);
                    !fld['readonly'] && (fld['usrSign'] = this.usrSgn.imageUrl);
                });
            }

            //Post form save handler for signature fields
            this.handleSignatureFlds = () => {
                this.signFlds.forEach(sf => {
                    let fld = this.fetchField(this.parsedForm, null, sf);
                    let dv = $('.parent-div-' + sf);
                    if(!!fld && !!this.parsedModel[sf] && !!this.parsedModel[sf]['signature']){
                        fld['isSignLckd'] = true;   //Lock the signature
                    } else if(fld['isRequired'] && !dv.hasClass('no-edit-role') && (!this.parsedModel[sf] || !this.parsedModel[sf]['signature'])){
                        dv.addClass('req-fld-div');     //Show required field msg
                        if(!!this.parsedModel[sf] && !this.parsedModel[sf]['signature']){
                            this.parsedModel[sf] = undefined;
                        }
                    }
                })
            }
            this.setIntervalToCheckParsedFieldStatus = (setModelBak=null) => {
                this.$interval.cancel(this.promise);
                this.promise = this.$interval(
                    () => {
                        if (this.pendingParsedFields == 0) {
                            this.$interval.cancel(this.promise);
                            this.modelBak = !!setModelBak? setModelBak : _.cloneDeep(this.parsedModel);
                            this.$scope.modelBak = this.modelBak;
                            this.modelUpdated = this.isModelChanged();
                            this.$scope.scopeVar = this;
                            this.formParsed = true;
                        }
                    }, 1000);
            }
            this.parseForm = (config, cstmAttrReadOnly, subject, embeddedForm=false, selectedSubject=null, service=null, frmSaved=false, frmReadOnly=null, setModel=null, setModelBak=null) => {
                let mbk = setModelBak? _.cloneDeep(this.modelBak) : null;
                this.formConfig = config;
                this.setModel = setModel;
                this.parsedForm = [];
                this.parsedSchema = {};
                cstmAttrReadOnly != null && (this.readOnly = cstmAttrReadOnly);
                frmReadOnly != null && (this.isReadOnly = frmReadOnly);
                this.requiredFlds = config.required;
                this.parsedModel = {};
                this.deferredModel = {};
                this.parsedSchema.type = "object";
                this.parsedSchema.properties = {};
                this.FieldService.init(null, this);
                this.currentUser = this.$_cache.getUser();
                this.orgId = !embeddedForm ? this.currentUser.organizationId : null;
                this.orgPartyId = !embeddedForm ? this.currentUser.orgPartyId : null;
                this.formOrgId = config.orgId;
                this.subject = subject;
                !!this.subject && (this.subjectId = subject.subjectId);
                this.crntUserIsOfSubjOrg = !!this.subject && this.subject.teamOrgName == this.currentUser.organizationName;
                this.isUsrCaptainOrCocaptain = !!this.subject && (this.subject.ownerId == this.currentUser.id || !!this.subject.coCaptain);
                this.usrSgn = !embeddedForm ? this.$_cache.getUserSignature() : null;
                this.usrPswd = !embeddedForm ? this.$_cache.getPassword() : null;
                this.apiKey = window['apiKey'];
                this.formUsers = config.formUsers;
                this.fieldConfigurationsData = [];
                this.pendingDUS = 0;
                this.selectedSubject = selectedSubject;
                !!this.selectedSubject && (this.selSubjId = this.selectedSubject.subjectId);
                this.service = service;
                this.frmSaved = !!frmSaved;
                this.parsedSignature = {};
                this.fieldCounter = 0;
                this.pendingParsedFields = 0;
                this.formParsed = false;
                !!subject && (this.teamOrgId = subject.teamOrgId);
                this.validationMsg = {
                    "regex": Util.FORM_VALIDATION_MSGS.REGEX,
                    "minDate": Util.FORM_VALIDATION_MSGS.MIN_DATE,
                    "maxDate": Util.FORM_VALIDATION_MSGS.MAX_DATE,
                    "date": Util.FORM_VALIDATION_MSGS.INVALID,
                    "maxFiles": Util.FORM_VALIDATION_MSGS.MAX_FILES,
                    0: Util.FORM_VALIDATION_MSGS.INVALID,
                    1: Util.FORM_VALIDATION_MSGS.INVALID_CHOICE,
                    101: Util.FORM_VALIDATION_MSGS.MIN_VALUE,
                    103: Util.FORM_VALIDATION_MSGS.MAX_VALUE,
                    200: Util.FORM_VALIDATION_MSGS.MIN_LENGTH,
                    201: Util.FORM_VALIDATION_MSGS.MAX_LENGTH,
                    302: Util.FORM_VALIDATION_MSGS.REQUIRED,
                    "maxlength": Util.FORM_VALIDATION_MSGS.MAX_LENGTH,
                    "alreadyExists": Util.FORM_VALIDATION_MSGS.ALREADY_EXISTS,
                    "emptyValue": Util.FORM_VALIDATION_MSGS.EMPTY_VAL,
                    "notAuthorized": Util.FORM_VALIDATION_MSGS.NOT_AUTHORIZED,
                    "depMinDate": Util.FORM_VALIDATION_MSGS.DEP_MIN_DATE,
                    "depMaxDate": Util.FORM_VALIDATION_MSGS.DEP_MAX_DATE,
                    "equalValue" : Util.FORM_VALIDATION_MSGS.EQUAL_VALUE
                };

                if (!!config.status && config.status == 'SUBMITTED') {
                    this.submittedForm = true;
                    this.dateSubmitted = config.dateSubmitted;
                    this.activeGoals = config.dateSubmitted;
                }
                !!config.isMultipleTeams && (this.isMultipleTeams = config.isMultipleTeams);
                for (var i = 0 ; i < config.sections.length; i++) {
                    var tempSection = this.parseSection(config.sections[i]);
                    this.parsedForm.push(tempSection);
                }

                this.setIntervalToCheckParsedFieldStatus(mbk);

                if(!!config.formSignature) {
                    this.parseSignature(config.formSignature);
                }

                this.FieldService.fields = this.dynamicFields;
                this.FieldService.initFields(this.dynamicFields);
                jsonLogic.add_operation('getNonUTCDate', Util.getNonUTCDate);
                jsonLogic.add_operation('lodash', _);
                jsonLogic.add_operation('isModelChanged', this.cmpareObj);
                jsonLogic.add_operation('mapArrays', this.mapArrays);
                jsonLogic.add_operation('reduceArrayByProperties', this.reduceArrayByProperties);
                jsonLogic.add_operation('getDateTime', (milli) => { return new Date(milli);});
                jsonLogic.add_operation("Moment", moment);
                jsonLogic.add_operation("addFieldInArrayObject",this.addFieldInArrayObject);
                return {
                    form: this.parsedForm,
                    schema: this.parsedSchema,
                    model: this.parsedModel,
                    signature: this.parsedSignature,
                    timePckrFlds: this.timePckrFlds,
                    reqFlds: this.checkReqFldValidation,
                    signFlds: this.signFlds,
                    fieldConfigurationsData: this.fieldConfigurationsData,
                    fldCounter: this.fieldCounter,
                    skipFields: this.skipFields,
                    autofilled: this.autofilled,
                    cstmAttrFlds: this.cstmAttrFlds
                };
            }

            this.checkPermission = (subject,permObj)=>{
                return subject.userPerm[permObj.target][permObj.action];
            }

            this.isModelChanged = (): boolean => {
                return this.cmpareObj(this.parsedModel, this.modelBak);
            }

            this.cmpareObj = (parsed, backup) => {
                var a = {};
                var b = {};
                for (var i in parsed) {
                    if (!!parsed[i]) {
                        a[i] = parsed[i];
                    }
                }
                for (var j in backup) {
                    if (!!backup[j]) {
                        b[j] = backup[j];
                    }
                }
                if (!!angular.equals(a, b)) {
                    return false;
                }
                return true;
            }
            this.resetBckndErrors = (scope) => {
                if (!!this.bckndErrors) {
                    this.bckndErrors.forEach(e => {
                        let fld = this.parsedSchema.properties[e.code];
                        if (!!fld) {
                            if (_.includes([FIELD_TYPE.COMPOSITE_LIST, FIELD_TYPE.COMPOSITE, FIELD_TYPE.TABLE], fld['valueType'])) {
                                let errCodes = Object.keys(e.details);
                                errCodes.forEach(k => {
                                    let keys = k.split('.');
                                    let div;
                                    if (keys.length > 2) {
                                        div = $('.' + keys[0]).find('.' + keys[1]);
                                    } else {
                                        div = $('.' + keys[0]);
                                    }
                                    if (!!div) {
                                        let el = div.find('[sf-message]');
                                        if (!!el) {
                                            div.removeClass("has-error");
                                            el.html("");
                                        }
                                    }
                                });
                            } else {
                                let errCodes = Object.keys(e.details);
                                errCodes.forEach(k => {
                                    scope.$broadcast('schemaForm.error.' + e.code, k, true);
                                })
                            }

                        }
                    });
                    this.bckndErrors = [];
                }
            }

            this.parseErrors = (scope, errors) => {
                let rg = new RegExp(/^\d+$/);
                this.bckndErrors = errors;
                errors.forEach(e => {
                    let fld = this.parsedSchema.properties[e.code];
                    if (!!fld) {
                        if (_.includes([FIELD_TYPE.COMPOSITE_LIST, FIELD_TYPE.COMPOSITE, FIELD_TYPE.TABLE], fld['valueType'])) {
                            let errCodes = Object.keys(e.details);
                            errCodes.forEach(k => {
                                let keys = k.split('.');
                                let div;
                                if (keys.length > 2) {
                                    div = $('.' + keys[0]).find('.' + keys[1]);
                                } else {
                                    //For fileUpload field key is numeric, so need to prepend "fileUpload"
                                    let fldInd = keys[0].split('-').slice(-1)[1];
                                    let rplStr = keys[0].split('-').slice(-1)[0];
                                    if(!!rg.test(fldInd) && !!rg.test(rplStr)){
                                        keys[0] = _.replace(keys[0], rplStr, FIELD_TYPE.FILE_UPLOAD + rplStr);
                                    }
                                    ////////////
                                    div = $('.' + keys[0]);
                                }
                                if (!!div && div.length > 0) {
                                    let el = div.find('> [sf-message]');
                                    if (!!el && el.length > 0) {
                                        div.addClass("has-error");
                                        el.html(e.details[k]);
                                    } else {
                                        var errDiv = document.createElement('div');
                                        div.addClass("has-error");
                                        errDiv.classList.add("help-block", "ml-5");
                                        errDiv.innerHTML = e.details[k];
                                        div.append(errDiv);
                                    }
                                }
                            });
                        } else {
                            //For fileUpload field key is numeric, so need to prepend "fileUpload"
                            let rplStr = e.code.split('-').slice(-1)[0];
                            if(!!rg.test(rplStr)){
                                e.code = _.replace(e.code, rplStr, FIELD_TYPE.FILE_UPLOAD + rplStr);
                            }
                            ///////////
                            let errCodes = Object.keys(e.details);
                            errCodes.forEach(k => {
                                scope.$broadcast('schemaForm.error.' + e.code, k, e.details[k]);
                            })
                        }
                    }
                });
            }

            this.getErrorCode = (errorCode: any) => {
                switch (errorCode) {
                    case 'FIELD_WRONG_TYPE':
                        return 0;
                    case 'FIELD_MISSING_REQUIRED':
                    case 'FIELD_REQUIRED':
                        return 302;
                    case 'FIELD_TOO_HIGH':
                        return 103;
                    case 'FIELD_TOO_LOW':
                        return 101;
                    case 'FIELD_TOO_LONG':
                        return 201;
                    case 'FIELD_TOO_SHORT':
                        return 200;
                    case 'FIELD_BAD_SYNTAX':
                        return 'regex';
                    case 'FIELD_TOO_EARLY':
                        return 'minDate';
                    case 'FIELD_TOO_LATE':
                        return 'maxDate';
                    case 'FIELD_TOO_MANY_FILES':
                        return 'maxFiles';
                    case 'FIELD_INVALID_CHOICE':
                        return 1;
                    case 'FIELD_INVALID_LIST_OPTION_VAL':
                        return 1;
                    case 'UNAUTHORIZED_EDIT':
                        return 'notAuthorized';
                    default:
                        return null;
                }
            }

            this.parseBackendErrors = (data: any, scope: any) => {
                this.parsedErrors = [];
                data.forEach(d => {
                    let dataPayload = !!d.payload ? d.payload : (Array.isArray(d) ? d : [d]);
                    dataPayload.forEach(p => {
                        let objId = p.objectId || d.objectId;
                        this.parsedErrors.push({
                            fieldId: objId,
                            errorCode: this.getErrorCode(p.errorCode),
                            message: p.message,
                            details: p.details
                        });
                    })

                });

                this.parsedErrors.forEach(err => {
                    let fieldId = err.fieldId;
                    let error = err.errorCode;
                    let fld = this.parsedSchema.properties['field' + fieldId];
                    if(!!fld && fld.type == FIELD_TYPE.PHONE_NUMBER){
                        fieldId += '-phone';
                    }
                    if (_.includes([FIELD_TYPE.COMPOSITE_LIST, FIELD_TYPE.COMPOSITE, FIELD_TYPE.TABLE], fld['valueType'])) {
                        if(!!err.details){
                            let errCodes = Object.keys(err.details);
                            errCodes.forEach(k => {
                                let keys = k.split('.');
                                let div, errMsg;
                                if (keys.length > 2) {
                                    div = $('.field' + keys[0]).find('.field' + keys[1]);
                                    errMsg = this.validationMsg[this.getErrorCode(keys[2])];
                                } else {
                                    div = $('.field' + keys[0]);
                                    errMsg = this.validationMsg[this.getErrorCode(keys[1])];
                                }
                                if (!!div) {
                                    let el = div.find('[sf-message]');
                                    if (!!el) {
                                        div.addClass("has-error");
                                        el.html(errMsg);
                                    }
                                }
                            });
                        } else {
                            let div = $('.parent-div-field' + fieldId);
                            if (!!div) {
                                $('<div class="cstm-err help-block"></div>').appendTo('.parent-div-field' + fieldId);
                                let el = div.find('.cstm-err');
                                if (!!el) {
                                    div.addClass("has-error");
                                    el.html(err.message);
                                }
                            }
                        }
                    } else {
                        switch (error) {
                            case 'regex':
                            case 'minDate':
                            case 'maxDate':
                            case 'maxFiles':
                            case 'notAuthorized':
                                scope.$broadcast('schemaForm.error.field' + fieldId, error, false);
                                break;
                            default:
                                scope.$broadcast('schemaForm.error.field' + fieldId, 'tv4-' + error, false);
                                break;
                        }
                    }
                });
            }

            this.handleErrors = (error, $rootScope) => {
                if (Array.isArray(error)) {
                    error.forEach(e => {
                        let errElement = $(".cstm-attr-popup " + "span[name = '" + e.code + "-error']");
                        if (!!errElement) {
                            let errCodes = Object.keys(e.details);
                            let msg = e.details[errCodes[0]];
                            for (var i = 1; i < errCodes.length; i++) {
                                msg += " | " + e.details[errCodes[i]];
                            };
                            errElement.text(msg);
                        }
                    });
                    this.parseErrors(this.$scope, error);
                    $rootScope.mainShowLoader = null;
                    let vldMsg = 'Please correct any errors before submitting';
                    this.$_snack.showErrorToastr({ message: vldMsg });
                } else {
                    this.PopUpService.openInformationModal(error);
                }
            }

            this.handleRequiredFieldValidations = ($timeout, containerClass, validateForm=null) => {
                //For required field validation
                let frmValid = true;
                let context = this;
                let prntClass = "." + containerClass + " ";
                this.checkReqFldValidation.forEach(r => {
                    if(_.includes(r, '[]')){   //composite list | subject[].firstName | subject[].contactphone-phone | subject[].adoptiveParentGuardian.parentGuardian1
                        let keys = r.split('[].');
                        let prnt = keys[0];
                        let sub = keys[1];
                        if(!!this.parsedModel[prnt]) {
                            this.parsedModel[prnt].forEach((s,index) => {
                                let subFldDiv = sub;
                                if(_.includes(sub, '-')) { //For phone number fields
                                    subFldDiv = sub.split('-').join(' .'); //contactphone-phone --> contactphone .phone
                                }
                                if(_.includes(sub, '.')) { //For composite objects
                                    subFldDiv = sub.split('.').join(' .'); // adoptiveParentGuardian.parentGuardian1 --> adoptiveParentGuardian .parentGuardian1
                                }
                                let dv = $(prntClass + "."+prnt+"-"+index+"-"+subFldDiv); //.add-multiple-subject .subject-0-contactPhone .phone
                                if(dv.length > 0 && !$(dv).hasClass('no-edit-role')){
                                    let mdl = s[sub];
                                    if($(dv).hasClass('schema-form-fileUpload') && !!mdl['documents']){
                                        if( mdl['documents'].length == 0 ){
                                            $timeout(() => {
                                                dv.addClass('req-fld-div has-error');
                                            },100);
                                            frmValid = false;
                                        } else {
                                            $timeout(() => {
                                                dv.removeClass('req-fld-div');
                                                if(!(dv.scope() as any).hasError()) {
                                                    dv.removeClass('has-error');
                                                }
                                            },100);
                                        }
                                    } else {
                                        if(mdl == undefined || mdl === '' || (Array.isArray(mdl) && mdl.length == 0)){
                                            $timeout(() => {
                                                dv.addClass('req-fld-div has-error');
                                            },100);
                                            frmValid = false;
                                        } else {
                                            $timeout(() => {
                                                dv.removeClass('req-fld-div');
                                                if(!(dv.scope() as any).hasError()) {
                                                    dv.removeClass('has-error');
                                                }
                                            },100);
                                        }
                                    }
                                }
                            })
                        }
                    } else {
                        let dv = (_.includes(r, '.'))? $(prntClass + "."+ _.replace(r, '.', '-')) : $(prntClass + ".parent-div-"+r);
                        if(dv.length > 0 && !$(dv).hasClass('no-edit-role')){
                            let mdl = _.get(this.parsedModel, r);
                            if($(dv).hasClass('schema-form-fileUpload') && !!mdl['documents']){
                                if( mdl['documents'].length == 0 ){
                                    $timeout(() => {
                                        dv.addClass('req-fld-div has-error');
                                    },100);
                                    frmValid = false;
                                } else {
                                    $timeout(() => {
                                        dv.removeClass('req-fld-div');
                                        if(!(dv.scope() as any).hasError()) {
                                            dv.removeClass('has-error');
                                        }
                                    },100);
                                }
                            } else {
                                if(mdl == undefined || mdl === '' || (Array.isArray(mdl) && mdl.length == 0)){
                                    $timeout(() => {
                                        dv.addClass('req-fld-div has-error');
                                    },100);
                                    frmValid = false;
                                } else {
                                    $timeout(() => {
                                        dv.removeClass('req-fld-div');
                                        if(!(dv.scope() as any).hasError()) {
                                            dv.removeClass('has-error');
                                        }
                                    },100);
                                }
                            }

                        }
                    }
                });
                if(!!validateForm){
                    if(frmValid){
                        this.$scope[validateForm].cstmAttrForm.$setValidity('responseRequired', true);
                    } else {
                        this.$scope[validateForm].cstmAttrForm.$setValidity('responseRequired', false);
                    }
                }
            }

            this.parseStateGroups = (result) => {
                result = result.map((gn) => {
                    let mn = result.find(g => g.id == gn.parentId);
                    gn.parentPartyName = !!mn? mn.label : undefined;
                    return gn;
                });
                result = result.filter(f => !f.disableSelection);
                let orgGrp = _.remove(result, (r)=> r.type == 'ORG');
                result = _.sortBy(result, ['label']);
                return _.concat(orgGrp,result);
            }

            this.stateGroupBy = function (item){
                return item.parentPartyName;
            };

            this.parseTeamRoles = (result) => {
                let roles = result.sort(
                    (a, b) => {
                        return (!!a.roleName) ? a.roleName.toLowerCase().localeCompare((!!b.roleName) ? b.roleName.toLowerCase() : '') : ((!!b.roleName) ? b.roleName.toLowerCase() : '');
                    }
                );

                roles = roles.filter(function (role) {
                    return !!role.roleName && role.roleName.length > 0;
                });

                return roles;
            }
        }
    }

